var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "guarantee-label-full-image",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 269.29 283.46"
      }
    },
    [
      _c("defs", [
        _c("clipPath", { attrs: { id: "gtl-clippath" } }, [
          _c("polygon", {
            staticClass: "gtl-cls-11",
            attrs: {
              points: "192.48 80.45 192.63 80.45 192.48 80.6 192.48 80.45"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-1" } }, [
          _c("polygon", {
            staticClass: "gtl-cls-12",
            attrs: {
              points: "192.18 80.15 192.03 80.15 192.18 80 192.18 80.15"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-2" } }, [
          _c("path", {
            staticClass: "gtl-cls-11",
            attrs: {
              d:
                "M246.75,84.49v1.79h1.79v-1.79h-1.79ZM244.96,84.49v1.79h1.79v-1.79h-1.79ZM243.17,84.49v1.79h1.79v-1.79h-1.79ZM241.37,84.49v1.79h1.79v-1.79h-1.79ZM237.78,84.49v5.38h1.79v-5.38h-1.79ZM235.99,84.49v5.38h1.79v-5.38h-1.79ZM234.19,84.49v5.38h1.79v-5.38h-1.79ZM228.81,84.49v3.59h1.79v-3.59h-1.79ZM223.43,84.49v1.79h1.79v-1.79h-1.79ZM216.25,84.49v1.79h1.79v-1.79h-1.79ZM214.46,84.49v8.97h1.79v-8.97h-1.79ZM239.58,86.28v5.38h1.79v-5.38h-1.79ZM232.4,86.28v1.79h1.79v-1.79h-1.79ZM218.05,86.28v3.59h1.79v-3.59h-1.79ZM210.87,86.28v1.79h1.79v-1.79h-1.79ZM244.96,88.08v5.38h1.79v-5.38h-1.79ZM241.37,88.08v1.79h1.79v-1.79h-1.79ZM227.02,88.08v1.79h1.79v-1.79h-1.79ZM225.22,88.08v1.79h1.79v-1.79h-1.79ZM223.43,88.08v7.18h1.79v-7.18h-1.79ZM221.64,88.08v3.59h1.79v-3.59h-1.79ZM219.84,88.08v1.79h1.79v-1.79h-1.79ZM212.67,88.08v1.79h1.79v-1.79h-1.79ZM243.17,89.87v1.79h1.79v-1.79h-1.79ZM237.78,91.66v3.59h1.79v-3.59h-1.79ZM234.19,91.66v3.59h1.79v-3.59h-1.79ZM232.4,91.66v1.79h1.79v-1.79h-1.79ZM228.81,91.66v1.79h1.79v-1.79h-1.79ZM219.84,91.66v1.79h1.79v-1.79h-1.79ZM212.67,91.66v3.59h1.79v-3.59h-1.79ZM246.75,93.46v5.38h1.79v-5.38h-1.79ZM239.58,93.46v5.38h1.79v-5.38h-1.79ZM221.64,93.46v5.38h1.79v-5.38h-1.79ZM216.25,93.46v1.79h1.79v-1.79h-1.79ZM243.17,95.25v1.79h1.79v-1.79h-1.79ZM235.99,95.25v1.79h1.79v-1.79h-1.79ZM232.4,95.25v1.79h1.79v-1.79h-1.79ZM228.81,95.25v1.79h1.79v-1.79h-1.79ZM225.22,95.25v1.79h1.79v-1.79h-1.79ZM218.05,95.25v1.79h1.79v-1.79h-1.79ZM214.46,95.25v5.38h1.79v-5.38h-1.79ZM210.87,95.25v10.76h1.79v-10.76h-1.79ZM237.78,97.05v5.38h1.79v-5.38h-1.79ZM219.84,97.05v3.59h1.79v-3.59h-1.79ZM216.25,97.05v1.79h1.79v-1.79h-1.79ZM212.67,97.05v1.79h1.79v-1.79h-1.79ZM259.31,98.84v3.59h1.79v-3.59h-1.79ZM250.34,98.84v5.38h1.79v-5.38h-1.79ZM248.55,98.84v3.59h1.79v-3.59h-1.79ZM241.37,98.84v1.79h1.79v-1.79h-1.79ZM234.19,98.84v1.79h1.79v-1.79h-1.79ZM228.81,98.84v5.38h1.79v-5.38h-1.79ZM227.02,98.84v3.59h1.79v-3.59h-1.79ZM225.22,98.84v10.76h1.79v-10.76h-1.79ZM207.28,98.84v1.79h1.79v-1.79h-1.79ZM198.31,98.84v3.59h1.79v-3.59h-1.79ZM196.52,98.84v1.79h1.79v-1.79h-1.79ZM261.11,100.64v5.38h1.79v-5.38h-1.79ZM257.52,100.64v1.79h1.79v-1.79h-1.79ZM252.14,100.64v3.59h1.79v-3.59h-1.79ZM239.58,100.64v1.79h1.79v-1.79h-1.79ZM235.99,100.64v1.79h1.79v-1.79h-1.79ZM223.43,100.64v1.79h1.79v-1.79h-1.79ZM221.64,100.64v1.79h1.79v-1.79h-1.79ZM218.05,100.64v1.79h1.79v-1.79h-1.79ZM201.9,100.64v1.79h1.79v-1.79h-1.79ZM246.75,102.43v1.79h1.79v-1.79h-1.79ZM243.17,102.43v7.18h1.79v-7.18h-1.79ZM241.37,102.43v1.79h1.79v-1.79h-1.79ZM232.4,102.43v1.79h1.79v-1.79h-1.79ZM230.61,102.43v1.79h1.79v-1.79h-1.79ZM219.84,102.43v5.38h1.79v-5.38h-1.79ZM207.28,102.43v1.79h1.79v-1.79h-1.79ZM205.49,102.43v7.18h1.79v-7.18h-1.79ZM203.7,102.43v1.79h1.79v-1.79h-1.79ZM196.52,102.43v5.38h1.79v-5.38h-1.79ZM257.52,104.22v3.59h1.79v-3.59h-1.79ZM253.93,104.22v8.97h1.79v-8.97h-1.79ZM248.55,104.22v1.79h1.79v-1.79h-1.79ZM244.96,104.22v8.97h1.79v-8.97h-1.79ZM234.19,104.22v7.18h1.79v-7.18h-1.79ZM227.02,104.22v3.59h1.79v-3.59h-1.79ZM221.64,104.22v3.59h1.79v-3.59h-1.79ZM218.05,104.22v7.18h1.79v-7.18h-1.79ZM212.67,104.22v1.79h1.79v-1.79h-1.79ZM209.08,104.22v3.59h1.79v-3.59h-1.79ZM198.31,104.22v5.38h1.79v-5.38h-1.79ZM250.34,106.02v1.79h1.79v-1.79h-1.79ZM241.37,106.02v1.79h1.79v-1.79h-1.79ZM239.58,106.02v1.79h1.79v-1.79h-1.79ZM235.99,106.02v3.59h1.79v-3.59h-1.79ZM232.4,106.02v1.79h1.79v-1.79h-1.79ZM223.43,106.02v1.79h1.79v-1.79h-1.79ZM216.25,106.02v1.79h1.79v-1.79h-1.79ZM207.28,106.02v1.79h1.79v-1.79h-1.79ZM200.11,106.02v1.79h1.79v-1.79h-1.79ZM259.31,107.81v1.79h1.79v-1.79h-1.79ZM246.75,107.81v1.79h1.79v-1.79h-1.79ZM230.61,107.81v1.79h1.79v-1.79h-1.79ZM228.81,107.81v5.38h1.79v-5.38h-1.79ZM214.46,107.81v1.79h1.79v-1.79h-1.79ZM212.67,107.81v1.79h1.79v-1.79h-1.79ZM210.87,107.81v7.18h1.79v-7.18h-1.79ZM203.7,107.81v1.79h1.79v-1.79h-1.79ZM201.9,107.81v1.79h1.79v-1.79h-1.79ZM261.11,109.61v3.59h1.79v-3.59h-1.79ZM255.72,109.61v1.79h1.79v-1.79h-1.79ZM250.34,109.61v7.18h1.79v-7.18h-1.79ZM239.58,109.61v1.79h1.79v-1.79h-1.79ZM216.25,109.61v1.79h1.79v-1.79h-1.79ZM209.08,109.61v1.79h1.79v-1.79h-1.79ZM207.28,109.61v1.79h1.79v-1.79h-1.79ZM200.11,109.61v1.79h1.79v-1.79h-1.79ZM196.52,109.61v1.79h1.79v-1.79h-1.79ZM259.31,111.4v5.38h1.79v-5.38h-1.79ZM257.52,111.4v1.79h1.79v-1.79h-1.79ZM252.14,111.4v1.79h1.79v-1.79h-1.79ZM248.55,111.4v1.79h1.79v-1.79h-1.79ZM241.37,111.4v8.97h1.79v-8.97h-1.79ZM235.99,111.4v5.38h1.79v-5.38h-1.79ZM232.4,111.4v10.76h1.79v-10.76h-1.79ZM230.61,111.4v5.38h1.79v-5.38h-1.79ZM225.22,111.4v3.59h1.79v-3.59h-1.79ZM223.43,111.4v1.79h1.79v-1.79h-1.79ZM219.84,111.4v1.79h1.79v-1.79h-1.79ZM212.67,111.4v1.79h1.79v-1.79h-1.79ZM255.72,113.19v1.79h1.79v-1.79h-1.79ZM246.75,113.19v1.79h1.79v-1.79h-1.79ZM237.78,113.19v3.59h1.79v-3.59h-1.79ZM234.19,113.19v1.79h1.79v-1.79h-1.79ZM227.02,113.19v8.97h1.79v-8.97h-1.79ZM221.64,113.19v5.38h1.79v-5.38h-1.79ZM214.46,113.19v7.18h1.79v-7.18h-1.79ZM207.28,113.19v1.79h1.79v-1.79h-1.79ZM205.49,113.19v3.59h1.79v-3.59h-1.79ZM201.9,113.19v10.76h1.79v-10.76h-1.79ZM198.31,113.19v1.79h1.79v-1.79h-1.79ZM196.52,113.19v3.59h1.79v-3.59h-1.79ZM248.55,114.99v1.79h1.79v-1.79h-1.79ZM243.17,114.99v1.79h1.79v-1.79h-1.79ZM223.43,114.99v3.59h1.79v-3.59h-1.79ZM219.84,114.99v1.79h1.79v-1.79h-1.79ZM218.05,114.99v5.38h1.79v-5.38h-1.79ZM216.25,114.99v1.79h1.79v-1.79h-1.79ZM209.08,114.99v1.79h1.79v-1.79h-1.79ZM200.11,114.99v3.59h1.79v-3.59h-1.79ZM261.11,116.78v1.79h1.79v-1.79h-1.79ZM253.93,116.78v3.59h1.79v-3.59h-1.79ZM244.96,116.78v1.79h1.79v-1.79h-1.79ZM239.58,116.78v5.38h1.79v-5.38h-1.79ZM234.19,116.78v1.79h1.79v-1.79h-1.79ZM210.87,116.78v5.38h1.79v-5.38h-1.79ZM207.28,116.78v1.79h1.79v-1.79h-1.79ZM252.14,118.58v3.59h1.79v-3.59h-1.79ZM250.34,118.58v5.38h1.79v-5.38h-1.79ZM248.55,118.58v3.59h1.79v-3.59h-1.79ZM246.75,118.58v3.59h1.79v-3.59h-1.79ZM235.99,118.58v7.18h1.79v-7.18h-1.79ZM230.61,118.58v1.79h1.79v-1.79h-1.79ZM225.22,118.58v1.79h1.79v-1.79h-1.79ZM216.25,118.58v1.79h1.79v-1.79h-1.79ZM212.67,118.58v1.79h1.79v-1.79h-1.79ZM209.08,118.58v1.79h1.79v-1.79h-1.79ZM203.7,118.58v1.79h1.79v-1.79h-1.79ZM198.31,118.58v1.79h1.79v-1.79h-1.79ZM196.52,118.58v3.59h1.79v-3.59h-1.79ZM261.11,120.37v1.79h1.79v-1.79h-1.79ZM257.52,120.37v1.79h1.79v-1.79h-1.79ZM255.72,120.37v1.79h1.79v-1.79h-1.79ZM244.96,120.37v1.79h1.79v-1.79h-1.79ZM237.78,120.37v1.79h1.79v-1.79h-1.79ZM223.43,120.37v1.79h1.79v-1.79h-1.79ZM221.64,120.37v3.59h1.79v-3.59h-1.79ZM207.28,120.37v1.79h1.79v-1.79h-1.79ZM205.49,120.37v1.79h1.79v-1.79h-1.79ZM243.17,122.16v1.79h1.79v-1.79h-1.79ZM228.81,122.16v5.38h1.79v-5.38h-1.79ZM219.84,122.16v1.79h1.79v-1.79h-1.79ZM214.46,122.16v3.59h1.79v-3.59h-1.79ZM203.7,122.16v5.38h1.79v-5.38h-1.79ZM200.11,122.16v3.59h1.79v-3.59h-1.79ZM198.31,122.16v3.59h1.79v-3.59h-1.79ZM253.93,123.96v1.79h1.79v-1.79h-1.79ZM248.55,123.96v3.59h1.79v-3.59h-1.79ZM246.75,123.96v1.79h1.79v-1.79h-1.79ZM239.58,123.96v1.79h1.79v-1.79h-1.79ZM237.78,123.96v1.79h1.79v-1.79h-1.79ZM234.19,123.96v3.59h1.79v-3.59h-1.79ZM232.4,123.96v10.76h1.79v-10.76h-1.79ZM227.02,123.96v3.59h1.79v-3.59h-1.79ZM225.22,123.96v1.79h1.79v-1.79h-1.79ZM216.25,123.96v3.59h1.79v-3.59h-1.79ZM212.67,123.96v3.59h1.79v-3.59h-1.79ZM210.87,123.96v1.79h1.79v-1.79h-1.79ZM207.28,123.96v1.79h1.79v-1.79h-1.79ZM196.52,123.96v1.79h1.79v-1.79h-1.79ZM261.11,125.75v3.59h1.79v-3.59h-1.79ZM259.31,125.75v3.59h1.79v-3.59h-1.79ZM255.72,125.75v1.79h1.79v-1.79h-1.79ZM250.34,125.75v1.79h1.79v-1.79h-1.79ZM244.96,125.75v3.59h1.79v-3.59h-1.79ZM241.37,125.75v1.79h1.79v-1.79h-1.79ZM223.43,125.75v3.59h1.79v-3.59h-1.79ZM219.84,125.75v1.79h1.79v-1.79h-1.79ZM209.08,125.75v1.79h1.79v-1.79h-1.79ZM201.9,125.75v1.79h1.79v-1.79h-1.79ZM257.52,127.55v1.79h1.79v-1.79h-1.79ZM253.93,127.55v16.15h1.79v-16.15h-1.79ZM243.17,127.55v1.79h1.79v-1.79h-1.79ZM239.58,127.55v1.79h1.79v-1.79h-1.79ZM230.61,127.55v1.79h1.79v-1.79h-1.79ZM225.22,127.55v16.15h1.79v-16.15h-1.79ZM221.64,127.55v1.79h1.79v-1.79h-1.79ZM218.05,127.55v1.79h1.79v-1.79h-1.79ZM207.28,127.55v1.79h1.79v-1.79h-1.79ZM198.31,127.55v1.79h1.79v-1.79h-1.79ZM255.72,129.34v1.79h1.79v-1.79h-1.79ZM250.34,129.34v1.79h1.79v-1.79h-1.79ZM246.75,129.34v19.73h1.79v-19.73h-1.79ZM228.81,129.34v5.38h1.79v-5.38h-1.79ZM214.46,129.34v7.18h1.79v-7.18h-1.79ZM212.67,129.34v5.38h1.79v-5.38h-1.79ZM210.87,129.34v3.59h1.79v-3.59h-1.79ZM205.49,129.34v1.79h1.79v-1.79h-1.79ZM201.9,129.34v1.79h1.79v-1.79h-1.79ZM261.11,131.13v1.79h1.79v-1.79h-1.79ZM257.52,131.13v3.59h1.79v-3.59h-1.79ZM252.14,131.13v5.38h1.79v-5.38h-1.79ZM248.55,131.13v1.79h1.79v-1.79h-1.79ZM243.17,131.13v3.59h1.79v-3.59h-1.79ZM237.78,131.13v3.59h1.79v-3.59h-1.79ZM234.19,131.13v7.18h1.79v-7.18h-1.79ZM230.61,131.13v1.79h1.79v-1.79h-1.79ZM227.02,131.13v5.38h1.79v-5.38h-1.79ZM221.64,131.13v5.38h1.79v-5.38h-1.79ZM216.25,131.13v1.79h1.79v-1.79h-1.79ZM207.28,131.13v1.79h1.79v-1.79h-1.79ZM200.11,131.13v1.79h1.79v-1.79h-1.79ZM196.52,131.13v1.79h1.79v-1.79h-1.79ZM259.31,132.93v5.38h1.79v-5.38h-1.79ZM241.37,132.93v3.59h1.79v-3.59h-1.79ZM235.99,132.93v1.79h1.79v-1.79h-1.79ZM223.43,132.93v8.97h1.79v-8.97h-1.79ZM219.84,132.93v5.38h1.79v-5.38h-1.79ZM218.05,132.93v3.59h1.79v-3.59h-1.79ZM209.08,132.93v3.59h1.79v-3.59h-1.79ZM261.11,134.72v1.79h1.79v-1.79h-1.79ZM250.34,134.72v1.79h1.79v-1.79h-1.79ZM248.55,134.72v1.79h1.79v-1.79h-1.79ZM230.61,134.72v10.76h1.79v-10.76h-1.79ZM216.25,134.72v1.79h1.79v-1.79h-1.79ZM210.87,134.72v3.59h1.79v-3.59h-1.79ZM207.28,134.72v1.79h1.79v-1.79h-1.79ZM205.49,134.72v1.79h1.79v-1.79h-1.79ZM201.9,134.72v1.79h1.79v-1.79h-1.79ZM257.52,136.52v1.79h1.79v-1.79h-1.79ZM244.96,136.52v1.79h1.79v-1.79h-1.79ZM237.78,136.52v5.38h1.79v-5.38h-1.79ZM235.99,136.52v1.79h1.79v-1.79h-1.79ZM232.4,136.52v7.18h1.79v-7.18h-1.79ZM255.72,138.31v1.79h1.79v-1.79h-1.79ZM250.34,138.31v1.79h1.79v-1.79h-1.79ZM243.17,138.31v3.59h1.79v-3.59h-1.79ZM239.58,138.31v3.59h1.79v-3.59h-1.79ZM228.81,138.31v1.79h1.79v-1.79h-1.79ZM218.05,138.31v3.59h1.79v-3.59h-1.79ZM216.25,138.31v3.59h1.79v-3.59h-1.79ZM214.46,138.31v3.59h1.79v-3.59h-1.79ZM259.31,140.1v1.79h1.79v-1.79h-1.79ZM257.52,140.1v1.79h1.79v-1.79h-1.79ZM244.96,140.1v8.97h1.79v-8.97h-1.79ZM241.37,140.1v1.79h1.79v-1.79h-1.79ZM234.19,140.1v5.38h1.79v-5.38h-1.79ZM227.02,140.1v1.79h1.79v-1.79h-1.79ZM221.64,140.1v1.79h1.79v-1.79h-1.79ZM219.84,140.1v1.79h1.79v-1.79h-1.79ZM252.14,141.9v3.59h1.79v-3.59h-1.79ZM250.34,141.9v8.97h1.79v-8.97h-1.79ZM248.55,141.9v3.59h1.79v-3.59h-1.79ZM212.67,141.9v3.59h1.79v-3.59h-1.79ZM261.11,143.69v1.79h1.79v-1.79h-1.79ZM255.72,143.69v5.38h1.79v-5.38h-1.79ZM243.17,143.69v1.79h1.79v-1.79h-1.79ZM241.37,143.69v1.79h1.79v-1.79h-1.79ZM239.58,143.69v1.79h1.79v-1.79h-1.79ZM237.78,143.69v1.79h1.79v-1.79h-1.79ZM227.02,143.69v1.79h1.79v-1.79h-1.79ZM223.43,143.69v3.59h1.79v-3.59h-1.79ZM221.64,143.69v1.79h1.79v-1.79h-1.79ZM216.25,143.69v1.79h1.79v-1.79h-1.79ZM214.46,143.69v7.18h1.79v-7.18h-1.79ZM253.93,145.49v1.79h1.79v-1.79h-1.79ZM235.99,145.49v5.38h1.79v-5.38h-1.79ZM232.4,145.49v3.59h1.79v-3.59h-1.79ZM228.81,145.49v1.79h1.79v-1.79h-1.79ZM225.22,145.49v3.59h1.79v-3.59h-1.79ZM219.84,145.49v1.79h1.79v-1.79h-1.79ZM252.14,147.28v3.59h1.79v-3.59h-1.79ZM243.17,147.28v3.59h1.79v-3.59h-1.79ZM239.58,147.28v3.59h1.79v-3.59h-1.79ZM237.78,147.28v3.59h1.79v-3.59h-1.79ZM221.64,147.28v3.59h1.79v-3.59h-1.79ZM218.05,147.28v3.59h1.79v-3.59h-1.79ZM216.25,147.28v1.79h1.79v-1.79h-1.79ZM210.87,147.28v3.59h1.79v-3.59h-1.79ZM261.11,149.08v1.79h1.79v-1.79h-1.79ZM259.31,149.08v1.79h1.79v-1.79h-1.79ZM257.52,149.08v1.79h1.79v-1.79h-1.79ZM253.93,149.08v1.79h1.79v-1.79h-1.79ZM230.61,149.08v1.79h1.79v-1.79h-1.79ZM228.81,149.08v1.79h1.79v-1.79h-1.79Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-3" } }, [
          _c("path", {
            staticClass: "gtl-cls-11",
            attrs: {
              d:
                "M196.52,84.49v12.56h12.56v-12.56h-12.56ZM198.31,86.28h8.97v8.97h-8.97v-8.97Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-4" } }, [
          _c("rect", {
            staticClass: "gtl-cls-11",
            attrs: { x: "200.11", y: "88.08", width: "5.38", height: "5.38" }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-5" } }, [
          _c("path", {
            staticClass: "gtl-cls-11",
            attrs: {
              d:
                "M262.9,84.49h-12.56v12.56h12.56v-12.56ZM261.11,86.28v8.97h-8.97v-8.97h8.97Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-6" } }, [
          _c("rect", {
            staticClass: "gtl-cls-11",
            attrs: { x: "253.93", y: "88.08", width: "5.38", height: "5.38" }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-7" } }, [
          _c("path", {
            staticClass: "gtl-cls-11",
            attrs: {
              d:
                "M196.52,150.87h12.56v-12.56h-12.56v12.56ZM198.31,149.08v-8.97h8.97v8.97h-8.97Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "gtl-clippath-8" } }, [
          _c("rect", {
            staticClass: "gtl-cls-11",
            attrs: { x: "200.11", y: "141.9", width: "5.38", height: "5.38" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "gtl-Layer_3", "data-name": "Layer 3" } }, [
        _c("rect", {
          staticClass: "gtl-cls-8",
          attrs: { width: "269.52", height: "284.16" }
        })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "gtl-Layer_1", "data-name": "Layer 1" } }, [
        _c("rect", {
          staticClass: "gtl-cls-9",
          attrs: { x: "3.09", y: "2.63", width: "263.11", height: "165.38" }
        }),
        _vm._v(" "),
        _c("rect", {
          staticClass: "gtl-cls-9",
          attrs: { x: "3.09", y: "171.68", width: "263.11", height: "108.38" }
        }),
        _vm._v(" "),
        _c(
          "text",
          {
            staticClass: "gtl-cls-5",
            attrs: { transform: "translate(6.32 74.52)" }
          },
          [
            _c("tspan", { attrs: { x: "0", y: "0" } }, [
              _vm._v(_vm._s(_vm.brand))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "text",
          {
            staticClass: "gtl-cls-5",
            attrs: { transform: "translate(196.75 74.52)" }
          },
          [
            _c("tspan", { attrs: { x: "0", y: "0" } }, [
              _vm._v(_vm._s(_vm.model))
            ])
          ]
        ),
        _vm._v(" "),
        _c("line", {
          staticClass: "gtl-cls-10",
          attrs: { x1: "6.32", y1: "61.34", x2: "262.97", y2: "61.34" }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "gtl-cls-17",
          attrs: {
            d:
              "M229.14,0v39.02c0,1.72.91,3.24,2.24,3.75l13.63,5.22c.67.26,1.38.26,2.05.01l13.59-5.01c1.35-.5,2.27-2.03,2.27-3.76V0h-33.79Z"
          }
        }),
        _vm._v(" "),
        _c("g", [
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "244.74 15.39 246.04 14.44 247.33 15.39 246.84 13.86 248.15 12.92 246.53 12.92 246.04 11.37 245.54 12.92 243.92 12.92 245.23 13.86 244.74 15.39"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "238.04 17.19 239.34 16.24 240.63 17.19 240.14 15.66 241.45 14.72 239.83 14.72 239.33 13.17 238.84 14.72 237.22 14.72 238.53 15.66 238.04 17.19"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "234.43 18.08 233.94 19.63 232.32 19.63 233.63 20.57 233.14 22.1 234.43 21.16 235.73 22.1 235.23 20.57 236.55 19.63 234.93 19.63 234.43 18.08"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "232.63 27.85 233.93 28.79 233.44 27.27 234.75 26.32 233.13 26.32 232.63 24.77 232.14 26.33 230.52 26.32 231.83 27.27 231.34 28.79 232.63 27.85"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "234.93 33.03 234.43 31.49 233.94 33.04 232.32 33.03 233.63 33.98 233.14 35.51 234.43 34.56 235.73 35.51 235.23 33.98 236.55 33.03 234.93 33.03"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "239.84 37.95 239.34 36.4 238.85 37.95 237.23 37.95 238.54 38.89 238.05 40.42 239.35 39.47 240.64 40.42 240.15 38.89 241.46 37.95 239.84 37.95"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "246.53 39.73 246.04 38.18 245.54 39.73 243.92 39.73 245.23 40.67 244.74 42.2 246.04 41.25 247.33 42.2 246.84 40.67 248.15 39.73 246.53 39.73"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "253.22 37.95 252.73 36.4 252.23 37.95 250.61 37.95 251.93 38.89 251.43 40.42 252.73 39.47 254.02 40.42 253.53 38.89 254.85 37.95 253.22 37.95"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "258.14 33.03 257.64 31.49 257.14 33.04 255.52 33.03 256.84 33.98 256.35 35.51 257.64 34.56 258.94 35.51 258.44 33.98 259.76 33.03 258.14 33.03"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "261.54 26.3 259.92 26.3 259.42 24.76 258.92 26.31 257.3 26.3 258.62 27.25 258.13 28.78 259.42 27.83 260.71 28.78 260.22 27.25 261.54 26.3"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "256.35 22.08 257.64 21.14 258.94 22.08 258.44 20.55 259.76 19.61 258.14 19.61 257.64 18.06 257.14 19.61 255.52 19.61 256.84 20.55 256.35 22.08"
            }
          }),
          _vm._v(" "),
          _c("polygon", {
            staticClass: "gtl-cls-21",
            attrs: {
              points:
                "252.75 13.17 252.25 14.72 250.63 14.72 251.94 15.66 251.45 17.19 252.75 16.24 254.04 17.19 253.55 15.66 254.87 14.72 253.24 14.72 252.75 13.17"
            }
          })
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M30.59,24.41c-.28-.92-.67-1.75-1.17-2.48-.49-.73-1.09-1.36-1.77-1.88s-1.47-.92-2.36-1.18-1.85-.4-2.9-.4c-1.88,0-3.55.47-5.01,1.41-1.47.94-2.62,2.33-3.45,4.15-.83,1.82-1.25,4.04-1.25,6.66s.42,4.87,1.24,6.7c.83,1.83,1.98,3.22,3.46,4.17s3.19,1.42,5.15,1.42c1.77,0,3.31-.34,4.61-1.02,1.3-.68,2.3-1.65,3.01-2.91s1.06-2.73,1.06-4.42l1.43.22h-9.48v-4.94h14.16v4.19c0,2.99-.64,5.57-1.91,7.75-1.27,2.18-3.02,3.86-5.25,5.04-2.23,1.18-4.78,1.76-7.67,1.76-3.22,0-6.04-.72-8.46-2.17-2.43-1.45-4.32-3.51-5.68-6.19-1.36-2.68-2.04-5.85-2.04-9.54,0-2.82.4-5.33,1.2-7.55.8-2.22,1.92-4.1,3.37-5.65,1.44-1.55,3.14-2.73,5.08-3.55,1.94-.81,4.06-1.22,6.34-1.22,1.93,0,3.73.28,5.4.84s3.16,1.36,4.46,2.4,2.37,2.26,3.21,3.68,1.39,2.99,1.65,4.7h-6.44Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M47.31,48.17h-6.75l12.29-34.91h7.81l12.31,34.91h-6.75l-9.32-27.75h-.27l-9.31,27.75ZM47.54,34.48h18.41v5.08h-18.41v-5.08Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.05,48.17V13.26h13.09c2.68,0,4.93.47,6.76,1.4,1.82.93,3.2,2.24,4.14,3.91.94,1.68,1.41,3.63,1.41,5.86s-.47,4.18-1.42,5.82c-.95,1.64-2.34,2.91-4.18,3.8-1.84.89-4.1,1.34-6.78,1.34h-9.32v-5.25h8.47c1.57,0,2.85-.22,3.85-.66s1.74-1.08,2.22-1.93c.48-.85.72-1.89.72-3.13s-.24-2.3-.73-3.18c-.49-.88-1.23-1.55-2.23-2.01s-2.29-.69-3.87-.69h-5.8v29.62h-6.32ZM96.08,32.35l8.64,15.82h-7.06l-8.49-15.82h6.9Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M114.24,48.17h-6.75l12.29-34.91h7.81l12.31,34.91h-6.75l-9.32-27.75h-.27l-9.31,27.75ZM114.46,34.48h18.41v5.08h-18.41v-5.08Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M173.66,13.26v34.91h-5.62l-16.45-23.78h-.29v23.78h-6.32V13.26h5.66l16.43,23.8h.31V13.26h6.29Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("path", {
          staticClass: "gtl-cls-8",
          attrs: {
            d:
              "M242.54,33.44c-2.27-1.6-3.72-4.12-3.98-6.89l-.39-4.27,3.72-1.72c1.13-.52,2.34-.86,3.58-.94,1.58-.09,3.12.2,4.55.86l3.89,1.79-.16,1.75-1-.09.09-1.01-3.13-1.48c-.1-.04-.16-.07-.24-.11-1.25-.55-2.58-.79-3.95-.71-1.11.06-2.19.37-3.2.84l-3.09,1.43.32,3.57c.23,2.48,1.52,4.73,3.56,6.16l2.95,2.09,2.89-2.09c1.73-1.22,2.94-3.04,3.39-5.1l.12-.52h-6.43v-1h7.53l-.05.55c-.25,2.77-1.71,5.28-3.98,6.89l-3.5,2.47-3.5-2.47Z"
          }
        }),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-13" }, [
          _c("rect", {
            staticClass: "gtl-cls-8",
            attrs: { x: "192.33", y: "80.3", width: "74.75", height: "74.75" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-20" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "192.33", y: "80.3", width: "74.75", height: "74.75" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-16" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "196.52", y: "84.49", width: "12.56", height: "12.56" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-6" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "200.11", y: "88.08", width: "5.38", height: "5.38" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-14" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "250.34", y: "84.49", width: "12.56", height: "12.56" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-1" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "253.93", y: "88.08", width: "5.38", height: "5.38" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-2" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "196.52", y: "138.31", width: "12.56", height: "12.56" }
          })
        ]),
        _vm._v(" "),
        _c("g", { staticClass: "gtl-cls-15" }, [
          _c("rect", {
            staticClass: "gtl-cls-18",
            attrs: { x: "200.11", y: "141.9", width: "5.38", height: "5.38" }
          })
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.82,182.52v-5.09h1.95c.37,0,.67.06.92.17.25.12.43.27.55.47.12.2.18.42.18.68,0,.21-.04.38-.12.53-.08.15-.19.27-.32.36-.13.09-.28.16-.45.2v.05c.18,0,.35.06.52.17.17.1.3.24.41.42.11.18.16.4.16.66s-.06.5-.19.71c-.13.21-.32.38-.58.5-.26.12-.58.18-.97.18h-2.06ZM7.74,179.59h.91c.16,0,.3-.03.43-.09s.23-.14.3-.25c.07-.11.11-.24.11-.39,0-.2-.07-.36-.21-.49s-.34-.19-.62-.19h-.93v1.4ZM7.74,181.75h.99c.33,0,.58-.06.72-.19.15-.13.22-.29.22-.5,0-.15-.04-.29-.11-.41-.07-.12-.18-.22-.32-.29-.14-.07-.3-.11-.49-.11h-1.02v1.49Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M14.81,179.05c-.04-.13-.1-.25-.17-.36-.07-.11-.16-.2-.26-.28-.1-.08-.21-.13-.34-.17s-.27-.06-.42-.06c-.27,0-.52.07-.73.21s-.38.34-.5.61c-.12.27-.18.59-.18.97s.06.71.18.98.29.47.5.61c.21.14.47.21.75.21.26,0,.48-.05.67-.15s.34-.24.44-.42c.1-.18.15-.4.15-.64l.21.03h-1.38v-.72h2.07v.61c0,.44-.09.81-.28,1.13s-.44.56-.77.73c-.33.17-.7.26-1.12.26-.47,0-.88-.11-1.23-.32-.35-.21-.63-.51-.83-.9s-.3-.85-.3-1.39c0-.41.06-.78.17-1.1.12-.32.28-.6.49-.82.21-.23.46-.4.74-.52.28-.12.59-.18.92-.18.28,0,.54.04.79.12.24.08.46.2.65.35.19.15.35.33.47.54.12.21.2.44.24.69h-.94Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M23.19,177.43v.55h-2.46v4.54h-.62v-5.09h3.07Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M24.65,182.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM24.74,182.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M27.46,183.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.18-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM28.03,180.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M32.83,182.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM32.92,182.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M36.21,178.7v3.82h-.59v-3.82h.59ZM38.18,180.34v.55h-2.11v-.55h2.11ZM38.63,178.7v3.82h-.59v-3.82h.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M42.69,178.7v3.27h.54v1.78h-.59v-1.23h-2.95v-3.82h.59v3.27h1.83v-3.27h.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M44.69,181.65l1.84-2.95h.68v3.82h-.59v-2.95l-1.83,2.95h-.69v-3.82h.59v2.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M48.01,182.52l1.08-1.9h.64l-1.08,1.9h-.64ZM50.56,182.52v-3.28h-1.01c-.23,0-.41.05-.54.16-.13.11-.2.25-.2.44s.06.33.18.43c.12.1.28.16.49.16h1.23v.55h-1.23c-.26,0-.48-.05-.67-.14s-.33-.22-.43-.39c-.1-.17-.15-.37-.15-.61s.05-.44.16-.61.26-.3.46-.39c.2-.09.43-.14.71-.14h1.57v3.82h-.56Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M57.06,182.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM57.06,182.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M59.17,179.25v-.55h3.1v.55h-1.25v3.27h-.59v-3.27h-1.26Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M66.45,182.52v-3.82h3v3.82h-.59v-3.27h-1.83v3.27h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M70.51,183.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.18-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM71.08,180.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M76.3,182.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM76.3,182.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M79.49,181.65l1.84-2.95h.68v3.82h-.59v-2.95l-1.83,2.95h-.69v-3.82h.59v2.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M82.82,181.54h.63c.01.17.09.3.23.39.14.09.33.13.56.13s.44-.05.6-.15.25-.25.25-.47c0-.13-.03-.24-.09-.33-.06-.09-.15-.17-.27-.22-.11-.05-.25-.08-.41-.08h-.66v-.53h.66c.23,0,.41-.05.52-.16.11-.11.17-.24.17-.4,0-.17-.06-.31-.18-.41s-.29-.16-.51-.16-.41.05-.56.15-.23.23-.24.39h-.62c0-.21.07-.39.19-.55.12-.16.28-.28.49-.37.21-.09.44-.13.71-.13s.5.05.7.14.35.22.46.38.16.34.16.54c0,.22-.06.39-.18.52-.12.13-.27.23-.46.28v.04c.14.01.27.06.38.14.11.08.19.19.25.32s.09.28.09.44c0,.23-.06.43-.19.61-.12.17-.29.3-.51.4-.22.09-.46.14-.74.14s-.51-.04-.73-.13c-.21-.09-.38-.21-.51-.37s-.19-.34-.2-.55Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M86.5,182.52v-3.82h1.56c.41,0,.74.09.98.28.24.19.36.43.36.74,0,.23-.07.41-.21.54-.14.13-.31.21-.53.26.14.02.28.07.41.15.13.08.24.19.33.33.09.14.13.31.13.51s-.05.37-.15.52c-.1.15-.24.28-.43.37-.19.09-.41.13-.67.13h-1.8ZM87.05,180.3h1c.16,0,.29-.02.41-.07.11-.04.2-.11.26-.19s.09-.18.09-.29c0-.16-.07-.29-.2-.38-.13-.09-.32-.14-.55-.14h-1v1.06ZM87.05,181.98h1.24c.2,0,.36-.05.47-.14.11-.1.17-.23.17-.39,0-.2-.06-.35-.17-.47-.11-.11-.27-.17-.47-.17h-1.24v1.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M91.96,182.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM91.96,182.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M94.15,183.61v-1.64h.32c.08-.08.15-.17.2-.26.06-.09.11-.21.15-.34.04-.13.08-.29.11-.48.03-.19.06-.42.08-.68l.13-1.51h2.43v3.27h.59v1.64h-.59v-1.09h-2.82v1.09h-.59ZM95.14,181.97h1.84v-2.72h-1.29l-.1.96c-.04.4-.09.75-.15,1.05-.06.3-.16.54-.29.71Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.49,181.65l1.84-2.95h.68v3.82h-.59v-2.95l-1.83,2.95h-.69v-3.82h.59v2.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M102.54,179.25v-.55h3.1v.55h-1.25v3.27h-.59v-3.27h-1.26Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M107.88,182.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M110,182.52v-.55h.14c.11,0,.21-.02.29-.07.08-.04.14-.13.19-.24.05-.12.08-.28.11-.48.03-.21.04-.47.06-.79l.07-1.69h2.55v3.82h-.59v-3.27h-1.4l-.06,1.36c-.01.31-.04.59-.08.83-.04.24-.11.44-.19.6-.09.16-.2.28-.34.36-.14.08-.32.12-.53.12h-.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M114.19,182.52l1.08-1.9h.64l-1.08,1.9h-.64ZM116.74,182.52v-3.28h-1.01c-.23,0-.41.05-.54.16-.13.11-.2.25-.2.44s.06.33.18.43c.12.1.28.16.49.16h1.23v.55h-1.23c-.26,0-.48-.05-.67-.14s-.33-.22-.43-.39c-.1-.17-.15-.37-.15-.61s.05-.44.16-.61.26-.3.46-.39c.2-.09.43-.14.71-.14h1.57v3.82h-.56Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M121.69,182.52v-3.82h1.56c.41,0,.74.09.98.28.24.19.36.43.36.74,0,.23-.07.41-.21.54-.14.13-.31.21-.53.26.14.02.28.07.41.15.13.08.24.19.33.33.09.14.13.31.13.51s-.05.37-.15.52c-.1.15-.24.28-.43.37-.19.09-.41.13-.67.13h-1.8ZM122.25,180.3h1c.16,0,.29-.02.41-.07.11-.04.2-.11.26-.19s.09-.18.09-.29c0-.16-.07-.29-.2-.38-.13-.09-.32-.14-.55-.14h-1v1.06ZM122.25,181.98h1.24c.2,0,.36-.05.47-.14.11-.1.17-.23.17-.39,0-.2-.06-.35-.17-.47-.11-.11-.27-.17-.47-.17h-1.24v1.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M131.3,178.7v.55h-1.77v3.27h-.59v-3.82h2.36Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M133.48,182.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM133.48,182.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M135.68,183.61v-1.64h.32c.08-.08.15-.17.2-.26.06-.09.11-.21.15-.34.04-.13.08-.29.11-.48.03-.19.06-.42.08-.68l.13-1.51h2.43v3.27h.59v1.64h-.59v-1.09h-2.82v1.09h-.59ZM136.66,181.97h1.84v-2.72h-1.29l-.1.96c-.04.4-.09.75-.15,1.05-.06.3-.16.54-.29.71Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M141.02,181.65l1.84-2.95h.68v3.82h-.59v-2.95l-1.83,2.95h-.69v-3.82h.59v2.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M145.17,178.7v3.82h-.59v-3.82h.59ZM147.14,180.34v.55h-2.11v-.55h2.11ZM147.59,178.7v3.82h-.59v-3.82h.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M149.23,181.65l1.84-2.95h.68v3.82h-.59v-2.95l-1.83,2.95h-.69v-3.82h.59v2.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M156.99,175.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M166.07,179.14h-.93c-.03-.15-.08-.29-.15-.41s-.16-.22-.27-.3c-.11-.08-.23-.15-.36-.19-.13-.04-.28-.06-.44-.06-.28,0-.52.07-.74.21s-.38.34-.5.61c-.12.27-.18.59-.18.97s.06.72.18.98c.12.27.29.47.5.6.21.14.46.2.73.2.15,0,.3-.02.43-.06.13-.04.25-.1.36-.18.11-.08.2-.18.27-.29.07-.12.12-.25.15-.4h.93c-.03.25-.11.47-.22.69s-.27.4-.45.56c-.19.16-.4.29-.65.38-.25.09-.52.14-.83.14-.45,0-.85-.1-1.2-.31-.35-.21-.63-.51-.83-.9-.2-.39-.3-.86-.3-1.41s.1-1.02.31-1.41c.2-.39.48-.69.83-.9.35-.21.75-.31,1.19-.31.28,0,.55.04.79.12.24.08.46.2.65.35s.35.34.47.56c.12.22.2.47.24.76Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M169.66,178.83c-.02-.22-.12-.39-.29-.51-.17-.12-.39-.18-.67-.18-.19,0-.36.03-.5.09-.14.06-.24.14-.32.24s-.11.21-.11.34c0,.11.02.2.07.28.05.08.12.14.2.2.08.05.18.1.28.13.1.04.21.07.31.09l.48.12c.19.04.38.11.56.18.18.08.34.17.48.29s.25.26.34.42.12.36.12.58c0,.3-.08.56-.23.79-.15.23-.37.4-.66.53-.29.13-.63.19-1.04.19s-.74-.06-1.03-.18c-.29-.12-.52-.3-.68-.54s-.25-.52-.26-.86h.91c.01.18.07.33.16.44.1.12.22.21.38.26.15.06.33.09.52.09s.38-.03.53-.09c.15-.06.27-.14.36-.25s.13-.24.13-.38c0-.13-.04-.24-.12-.33s-.18-.16-.32-.22c-.14-.06-.3-.11-.48-.16l-.58-.15c-.42-.11-.75-.27-.99-.49-.24-.22-.36-.51-.36-.88,0-.3.08-.56.25-.79.16-.22.39-.4.67-.53.28-.12.6-.19.96-.19s.68.06.95.19.49.3.64.52c.16.22.24.48.24.76h-.89Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M174.31,182.52v-.45l2.74-4.1h-2.77v-.55h3.51v.45l-2.74,4.1h2.77v.55h-3.51Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M179.88,182.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM179.97,182.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM179.99,178.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.68,182.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M187.67,180.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M189.31,182.52v-5.09h.59v5.09h-.59ZM189.86,181.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM191.74,182.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M194.22,182.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM194.31,182.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M203.49,178.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M204.62,183.95c-.1,0-.19,0-.27-.02-.08-.02-.13-.03-.16-.05l.15-.52c.14.04.27.05.38.04.11,0,.21-.06.29-.14.08-.09.16-.23.23-.42l.11-.3-1.41-3.84h.64l1.05,3.04h.04l1.05-3.04h.64l-1.62,4.38c-.07.2-.16.36-.27.49-.11.13-.23.23-.37.29-.14.06-.3.09-.48.09ZM205.39,178.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M208.12,182.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.14,182.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM212.14,182.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M214.82,182.52v-5.09h.59v1.88h.05c.04-.07.1-.15.18-.25.08-.1.19-.2.33-.28.14-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05c-.14.3-.33.52-.57.69-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12s-.26-.18-.34-.28c-.08-.11-.14-.19-.18-.26h-.07v.59h-.57ZM215.4,180.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.12-.47.12-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51s-.37-.19-.62-.19-.44.06-.6.18c-.16.12-.29.29-.37.5s-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M220.62,182.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M224.55,182.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M233.47,178.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M238.16,177.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M240.81,182.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M244.92,178.7v.5h-1.98v-.5h1.98ZM243.52,177.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M247.35,182.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M251.36,182.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M254.28,180.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47s.42-.17.72-.17c.26,0,.49.05.68.16s.35.26.46.47.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.71-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M262.01,175.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M8.54,191.52h-1.73v-5.09h1.76c.51,0,.94.1,1.3.3.36.2.64.49.84.87.2.38.29.83.29,1.36s-.1.99-.29,1.37c-.2.38-.48.67-.85.88-.37.2-.81.31-1.33.31ZM7.74,190.72h.76c.35,0,.65-.06.89-.2.24-.13.42-.32.53-.58.12-.26.18-.58.18-.97s-.06-.71-.18-.97-.3-.45-.53-.58c-.23-.13-.52-.19-.87-.19h-.79v3.5Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M12.25,191.52h-.98l1.79-5.09h1.14l1.79,5.09h-.98l-1.36-4.05h-.04l-1.36,4.05ZM12.28,189.52h2.68v.74h-2.68v-.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M24.15,191.52v-5.09h1.72c.4,0,.73.07.98.21.25.14.44.34.57.58.12.24.18.51.18.82s-.06.57-.18.82c-.12.25-.31.44-.56.59-.25.14-.58.22-.97.22h-1.23v-.55h1.21c.27,0,.49-.05.66-.14s.29-.22.36-.38c.08-.16.11-.34.11-.55s-.04-.39-.11-.55c-.08-.16-.2-.29-.36-.38-.17-.09-.39-.14-.67-.14h-1.08v4.54h-.62Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M28.49,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M32.51,191.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM32.51,191.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M36.55,191.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM36.63,191.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M41.84,189.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M45.03,191.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M48.97,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M52.01,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M57.16,187.7v.5h-1.98v-.5h1.98ZM55.76,186.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M59.52,193.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM59.51,190.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M63.35,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM63.44,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M66.15,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M69.86,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM69.95,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M73.25,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.4,187.7v.5h-1.98v-.5h1.98ZM77,186.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M79.56,187.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM79.27,191.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M82.51,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M85.55,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M91.74,188.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.49,187.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M101.25,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM101.34,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M104.05,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M106.93,187.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM106.64,191.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.82,193.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM109.8,190.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M113.11,189.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47s.42-.17.72-.17c.26,0,.49.05.68.16s.35.26.46.47.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.71-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M118.24,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M122.13,191.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM122.21,191.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M129.01,187.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM128.71,191.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M135.17,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM135.26,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM135.55,187.27c-.17,0-.32-.04-.46-.11s-.25-.18-.33-.3c-.08-.13-.12-.27-.12-.43s.04-.3.12-.44.19-.24.33-.32c.14-.08.29-.12.46-.12s.32.04.46.12c.14.08.24.19.32.32.08.13.12.28.12.44s-.04.3-.12.43c-.08.13-.19.23-.32.3-.13.07-.29.11-.46.11ZM135.55,186.89c.14,0,.25-.05.34-.14.09-.1.13-.2.13-.32s-.04-.24-.13-.34c-.09-.1-.2-.15-.34-.15s-.25.05-.34.15c-.09.1-.13.21-.13.34s.04.23.13.32c.09.1.2.14.34.14Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M137.97,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M145.1,184.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M151.9,191.52h-1.73v-5.09h1.76c.51,0,.94.1,1.3.3.36.2.64.49.84.87.2.38.29.83.29,1.36s-.1.99-.29,1.37c-.2.38-.48.67-.85.88-.37.2-.81.31-1.33.31ZM151.1,190.72h.76c.35,0,.65-.06.89-.2.24-.13.42-.32.53-.58.12-.26.18-.58.18-.97s-.06-.71-.18-.97-.3-.45-.53-.58c-.23-.13-.52-.19-.87-.19h-.79v3.5Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M155.22,191.52v-5.09h3.31v.77h-2.39v1.38h2.22v.77h-2.22v1.39h2.41v.77h-3.33Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M163.27,191.52v-5.09h.62v2.27h2.71v-2.27h.62v5.09h-.62v-2.28h-2.71v2.28h-.62Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M169.95,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M172.4,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M177.69,188.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M180.29,187.7v.5h-1.98v-.5h1.98ZM178.88,186.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.71,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M185.75,186.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M187.39,186.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M190.05,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M192.5,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M196.51,193.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM196.49,190.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M200.33,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM200.42,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M203.14,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M206.84,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM206.93,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M210.23,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M215.38,187.7v.5h-1.98v-.5h1.98ZM213.98,186.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M216.55,187.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM216.25,191.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M219.49,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M225.94,187.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM225.64,191.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M227.86,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M237.08,186.43h.62v3.64c0,.32-.06.6-.18.83-.12.23-.29.4-.5.52-.22.12-.47.18-.77.18-.28,0-.53-.05-.74-.15-.22-.1-.39-.25-.51-.44-.12-.19-.19-.41-.19-.67h.61c0,.14.04.27.11.38.07.11.17.19.3.25s.27.09.43.09c.18,0,.33-.04.45-.11s.22-.18.28-.33c.07-.15.1-.32.1-.53v-3.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M239.95,191.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM240.04,191.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M243.34,189.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47s.42-.17.72-.17c.26,0,.49.05.68.16s.35.26.46.47.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.71-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M246.87,191.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M250.93,191.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M253.97,189.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M262.01,184.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.82,200.52v-5.09h3.31v.77h-2.39v1.38h2.22v.77h-2.22v1.39h2.41v.77h-3.33Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M11.05,200.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M17.01,200.52v-5.09h3.07v.55h-2.46v1.72h2.3v.55h-2.3v1.73h2.5v.55h-3.11Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M20.8,196.7h.64l1,2.9.98-2.9h.64l-1.33,3.74v1.51h-.59v-1.51l-1.34-3.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M24.52,196.7h.64l1,2.9.98-2.9h.64l-1.33,3.74v1.51h-.59v-1.51l-1.34-3.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M28.53,196.7h.59v2.35c0,.25.04.45.11.59.07.15.17.25.29.32.12.06.24.1.38.1.21,0,.4-.07.56-.2s.29-.31.38-.53c.09-.22.14-.47.14-.75,0-.19-.03-.39-.07-.61s-.09-.44-.16-.66-.14-.42-.21-.61h.62c.07.14.13.31.2.52s.11.43.15.67c.04.24.06.47.06.69,0,.26-.03.51-.09.75-.06.24-.16.46-.29.64s-.3.34-.51.45-.46.17-.74.17c-.41,0-.74-.12-1-.37-.26-.25-.38-.64-.38-1.18v-2.34ZM29.75,196.27l.17-1.16h.64l-.4,1.16h-.41Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M33.19,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v3.86h-.59v-3.82c0-.3-.08-.53-.23-.7-.15-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12s-.26.2-.35.36c-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M36.55,198.71v-.08c0-.34.07-.65.2-.92s.32-.49.57-.65.54-.24.89-.24c.07,0,.14.03.2.07s.13.09.2.15c.07.06.17.11.28.15.2.08.38.2.52.35.15.15.26.33.33.54.08.21.12.44.12.69v.07c0,.3-.07.58-.2.84-.13.27-.32.48-.56.65s-.54.25-.89.25-.65-.08-.89-.25c-.25-.17-.44-.39-.57-.67s-.2-.6-.2-.96ZM37.24,198.63v.08c0,.24.03.46.1.66s.17.37.32.49c.14.12.33.18.56.18s.41-.06.55-.18c.14-.12.25-.29.31-.49.07-.2.1-.42.1-.66v-.08c0-.23-.03-.43-.1-.62-.07-.19-.17-.35-.32-.46s-.33-.17-.56-.17-.41.06-.55.17-.25.27-.31.46-.1.4-.1.62ZM40.15,196.82v.55h-1.95v-.55h1.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M41.66,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v3.86h-.59v-3.82c0-.3-.08-.53-.23-.7-.15-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12s-.26.2-.35.36c-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M50.52,196.7v.55h-3.75v-.55h3.75ZM47.92,196.7v3.82h-.59v-3.82h.59ZM49.38,196.7h.59v2.87c0,.12.02.21.07.27.04.06.1.1.16.12.07.02.13.03.2.03.05,0,.11,0,.17-.02.06-.01.1-.02.13-.03v.55s-.12.03-.2.05c-.08.02-.19.03-.31.03-.23,0-.43-.07-.58-.22-.15-.15-.23-.41-.23-.77v-2.87Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M52.85,200.6c-.32,0-.6-.09-.83-.26-.24-.17-.42-.4-.55-.7-.13-.3-.2-.64-.2-1.03s.07-.72.21-1.01c.14-.29.33-.53.57-.69.24-.17.52-.25.84-.25.23,0,.43.04.6.13s.31.21.43.37c.12.16.22.34.3.54h.23l.09.9.5,1.92h-.55l-.47-1.92c-.03-.12-.06-.26-.11-.42-.05-.16-.12-.32-.21-.47-.09-.15-.2-.28-.33-.38-.13-.1-.29-.15-.48-.15-.2,0-.38.06-.54.18-.16.12-.28.29-.37.51-.09.22-.13.47-.13.75s.04.52.12.74c.08.22.2.39.35.52.15.13.32.19.52.19.18,0,.34-.05.48-.15.14-.1.25-.23.34-.39s.17-.31.22-.48c.06-.17.1-.31.13-.43l.42-1.92h.55l-.45,1.92-.09.93h-.2c-.09.21-.19.39-.32.54-.13.16-.28.28-.46.37-.18.09-.39.13-.62.13Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M55.88,201.94v-3.38c0-.43.07-.78.2-1.06.13-.28.32-.49.55-.63.23-.14.5-.21.79-.21.25,0,.48.05.67.15s.37.24.5.42c.14.18.24.4.32.66s.11.54.11.86v.07c0,.34-.06.65-.19.92-.13.27-.3.48-.54.63-.23.15-.51.23-.83.23-.26,0-.48-.05-.65-.15s-.33-.25-.45-.44c-.12-.19-.22-.41-.31-.67l.39-.49c0,.12.02.25.05.39s.09.27.16.4.18.23.31.31c.13.08.29.12.48.12.22,0,.41-.06.55-.17.14-.12.25-.27.32-.46.07-.19.1-.4.1-.62v-.07c0-.29-.04-.55-.11-.79-.07-.23-.18-.42-.33-.55s-.33-.2-.56-.2-.42.07-.56.2c-.14.14-.25.31-.31.51s-.1.42-.1.63l.02,3.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M61.29,200.6c-.32,0-.6-.09-.83-.26-.24-.17-.42-.4-.55-.7-.13-.3-.2-.64-.2-1.03s.07-.72.21-1.01c.14-.29.33-.53.57-.69.24-.17.52-.25.84-.25.23,0,.43.04.6.13s.31.21.43.37c.12.16.22.34.3.54h.23l.09.9.5,1.92h-.55l-.47-1.92c-.03-.12-.06-.26-.11-.42-.05-.16-.12-.32-.21-.47-.09-.15-.2-.28-.33-.38-.13-.1-.29-.15-.48-.15-.2,0-.38.06-.54.18-.16.12-.28.29-.37.51-.09.22-.13.47-.13.75s.04.52.12.74c.08.22.2.39.35.52.15.13.32.19.52.19.18,0,.34-.05.48-.15.14-.1.25-.23.34-.39s.17-.31.22-.48c.06-.17.1-.31.13-.43l.42-1.92h.55l-.45,1.92-.09.93h-.2c-.09.21-.19.39-.32.54-.13.16-.28.28-.46.37-.18.09-.39.13-.62.13Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M64.06,196.7h.64l1,2.9.98-2.9h.64l-1.33,3.74v1.51h-.59v-1.51l-1.34-3.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M68.43,196.7h.67c-.16.27-.28.52-.37.73s-.14.42-.17.61c-.03.19-.04.39-.04.59,0,.45.07.79.21,1.04s.34.37.58.37c.22,0,.39-.1.52-.29s.2-.47.2-.84v-1.14h.47v1.14c0,.36-.05.66-.14.92-.1.25-.24.44-.42.57s-.41.2-.67.2c-.29,0-.53-.08-.74-.24-.2-.16-.36-.39-.47-.69-.11-.3-.16-.66-.16-1.08,0-.34.04-.67.13-.98s.22-.61.4-.9ZM71.65,196.7h.67c.18.29.31.58.4.9s.13.64.13.98c0,.42-.05.78-.16,1.08-.11.3-.26.53-.47.69s-.45.24-.73.24c-.26,0-.49-.07-.67-.2s-.32-.32-.42-.57c-.1-.25-.14-.56-.14-.92v-1.14h.47v1.14c0,.37.07.65.2.84s.3.29.52.29c.17,0,.31-.06.43-.17.12-.11.21-.27.27-.48.06-.21.1-.46.1-.76,0-.2-.01-.4-.04-.59s-.09-.39-.17-.61c-.08-.21-.21-.46-.37-.73Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M73.43,196.7h.64l1,2.9.98-2.9h.64l-1.33,3.74v1.51h-.59v-1.51l-1.34-3.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M79,200.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM79,200.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M81.6,196.7h.59v2.35c0,.25.04.45.11.59.07.15.17.25.29.32.12.06.24.1.38.1.21,0,.4-.07.56-.2s.29-.31.38-.53c.09-.22.14-.47.14-.75,0-.19-.03-.39-.07-.61s-.09-.44-.16-.66-.14-.42-.21-.61h.62c.07.14.13.31.2.52s.11.43.15.67c.04.24.06.47.06.69,0,.26-.03.51-.09.75-.06.24-.16.46-.29.64s-.3.34-.51.45-.46.17-.74.17c-.41,0-.74-.12-1-.37-.26-.25-.38-.64-.38-1.18v-2.34ZM82.82,196.27l.17-1.16h.64l-.4,1.16h-.41Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M87.45,198.71v-.08c0-.34.07-.65.2-.92s.32-.49.57-.65.54-.24.89-.24c.07,0,.14.03.2.07s.13.09.2.15c.07.06.17.11.28.15.2.08.38.2.52.35.15.15.26.33.33.54.08.21.12.44.12.69v.07c0,.3-.07.58-.2.84-.13.27-.32.48-.56.65s-.54.25-.89.25-.65-.08-.89-.25c-.25-.17-.44-.39-.57-.67s-.2-.6-.2-.96ZM88.14,198.63v.08c0,.24.03.46.1.66s.17.37.32.49c.14.12.33.18.56.18s.41-.06.55-.18c.14-.12.25-.29.31-.49.07-.2.1-.42.1-.66v-.08c0-.23-.03-.43-.1-.62-.07-.19-.17-.35-.32-.46s-.33-.17-.56-.17-.41.06-.55.17-.25.27-.31.46-.1.4-.1.62ZM91.05,196.82v.55h-1.95v-.55h1.95Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M93.23,198.53h.52v.28h-.46c-.18,0-.33.03-.46.09s-.23.14-.3.23-.11.21-.11.33c0,.18.09.32.26.43s.41.16.69.16.49-.05.64-.16c.15-.11.25-.27.3-.49h.62c-.02.18-.07.34-.16.49-.08.15-.19.27-.33.37s-.3.18-.48.24c-.19.06-.39.08-.62.08-.29,0-.56-.05-.79-.14s-.42-.22-.55-.39c-.13-.17-.2-.36-.2-.58,0-.1.02-.21.06-.32.04-.11.11-.21.21-.31.1-.1.25-.17.43-.23.19-.06.43-.09.73-.09ZM93.75,198.69h-.52c-.29,0-.53-.03-.71-.08-.18-.06-.32-.13-.41-.22-.1-.09-.16-.19-.19-.3s-.05-.21-.05-.31c0-.24.06-.44.18-.6.12-.17.29-.3.51-.39s.47-.13.76-.13.54.04.76.13c.22.09.39.21.52.38.13.16.21.36.25.59h-.62c-.04-.17-.14-.31-.3-.42-.16-.11-.36-.16-.62-.16s-.47.06-.63.17c-.16.11-.24.25-.24.43,0,.16.07.29.21.38.14.1.34.14.62.14h.46v.39Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M98.92,198.53h.52v.28h-.46c-.18,0-.33.03-.46.09s-.23.14-.3.23-.11.21-.11.33c0,.18.09.32.26.43s.41.16.69.16.49-.05.64-.16c.15-.11.25-.27.3-.49h.62c-.02.18-.07.34-.16.49-.08.15-.19.27-.33.37s-.3.18-.48.24c-.19.06-.39.08-.62.08-.29,0-.56-.05-.79-.14s-.42-.22-.55-.39c-.13-.17-.2-.36-.2-.58,0-.1.02-.21.06-.32.04-.11.11-.21.21-.31.1-.1.25-.17.43-.23.19-.06.43-.09.73-.09ZM99.44,198.69h-.52c-.29,0-.53-.03-.71-.08-.18-.06-.32-.13-.41-.22-.1-.09-.16-.19-.19-.3s-.05-.21-.05-.31c0-.24.06-.44.18-.6.12-.17.29-.3.51-.39s.47-.13.76-.13.54.04.76.13c.22.09.39.21.52.38.13.16.21.36.25.59h-.62c-.04-.17-.14-.31-.3-.42-.16-.11-.36-.16-.62-.16s-.47.06-.63.17c-.16.11-.24.25-.24.43,0,.16.07.29.21.38.14.1.34.14.62.14h.46v.39ZM98.85,196.27l.17-1.16h.64l-.4,1.16h-.41Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M104.12,196.7v.55h-3.1v-.55h3.1ZM102.24,196.7h.59v2.89c0,.15.02.25.06.31.04.06.09.1.15.11.06.01.11.02.17.02.06,0,.12-.01.17-.04.06-.02.1-.05.13-.07l.16.47c-.11.08-.22.14-.33.16-.1.02-.21.04-.32.04-.26,0-.45-.08-.59-.24s-.2-.42-.2-.79v-2.86Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M105.32,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v3.86h-.59v-3.82c0-.3-.08-.53-.23-.7-.15-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12s-.26.2-.35.36c-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M111.57,193.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M114.85,200.52v-5.09h3.31v.77h-2.39v1.38h2.22v.77h-2.22v1.39h2.41v.77h-3.33Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M123.27,195.43v5.09h-.82l-2.4-3.47h-.04v3.47h-.92v-5.09h.83l2.4,3.47h.04v-3.47h.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M126.27,200.52v-5.09h1.72c.4,0,.73.07.98.21.25.14.44.34.57.58.12.24.18.51.18.82s-.06.57-.18.82c-.12.25-.31.44-.56.59-.25.14-.58.22-.97.22h-1.23v-.55h1.21c.27,0,.49-.05.66-.14s.29-.22.36-.38c.08-.16.11-.34.11-.55s-.04-.39-.11-.55c-.08-.16-.2-.29-.36-.38-.17-.09-.39-.14-.67-.14h-1.08v4.54h-.62Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M130.61,200.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M134.63,200.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM134.63,200.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M138.67,200.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM138.75,200.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M143.96,198.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M147.15,200.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M151.09,200.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M153.54,200.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M159.58,202.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM159.56,199.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M164.68,198.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M167.45,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM167.54,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M170.25,200.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M173.96,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM174.05,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M177.35,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.5,196.7v.5h-1.98v-.5h1.98ZM181.1,195.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M184.92,200.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M188.98,200.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M193.64,196.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM193.34,200.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M195.56,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M201.34,201.95c-.1,0-.19,0-.27-.02-.08-.02-.13-.03-.16-.05l.15-.52c.14.04.27.05.38.04.11,0,.21-.06.29-.14.08-.09.16-.23.23-.42l.11-.3-1.41-3.84h.64l1.05,3.04h.04l1.05-3.04h.64l-1.62,4.38c-.07.2-.16.36-.27.49-.11.13-.23.23-.37.29-.14.06-.3.09-.48.09Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M206.3,200.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M209.88,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM209.97,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.68,200.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M217.97,197.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M221.66,193.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M224.94,200.52v-5.09h3.31v.77h-2.39v1.38h2.22v.77h-2.22v1.39h2.41v.77h-3.33Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M231.94,196.83c-.02-.22-.12-.39-.29-.51-.17-.12-.39-.18-.67-.18-.19,0-.36.03-.5.09-.14.06-.24.14-.32.24s-.11.21-.11.34c0,.11.02.2.07.28.05.08.12.14.2.2.08.05.18.1.28.13.1.04.21.07.31.09l.48.12c.19.04.38.11.56.18.18.08.34.17.48.29s.25.26.34.42.12.36.12.58c0,.3-.08.56-.23.79-.15.23-.37.4-.66.53-.29.13-.63.19-1.04.19s-.74-.06-1.03-.18c-.29-.12-.52-.3-.68-.54s-.25-.52-.26-.86h.91c.01.18.07.33.16.44.1.12.22.21.38.26.15.06.33.09.52.09s.38-.03.53-.09c.15-.06.27-.14.36-.25s.13-.24.13-.38c0-.13-.04-.24-.12-.33s-.18-.16-.32-.22c-.14-.06-.3-.11-.48-.16l-.58-.15c-.42-.11-.75-.27-.99-.49-.24-.22-.36-.51-.36-.88,0-.3.08-.56.25-.79.16-.22.39-.4.67-.53.28-.12.6-.19.96-.19s.68.06.95.19.49.3.64.52c.16.22.24.48.24.76h-.89Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M239.2,197.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.38-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.12.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.91-.19-.39-.28-.85-.28-1.39,0-.4.05-.77.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M241.94,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM242.03,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M244.74,200.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M248.45,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM248.54,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M251.84,198.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M256.99,196.7v.5h-1.98v-.5h1.98ZM255.59,195.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M257.85,200.52v-3.82h.59v3.82h-.59ZM257.88,196.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M260.62,200.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM260.71,200.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M8.3,209.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM8.38,209.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M12.78,209.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M15.82,204.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M18.68,210.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.18-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM19.25,207.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M22.92,209.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M26.94,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM26.94,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M30.98,209.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM31.06,209.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M36.27,207.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M39.46,209.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M43.46,205.7v.5h-1.98v-.5h1.98ZM42.06,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M45.83,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM45.83,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M48.44,209.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M54.43,209.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M57.47,207.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M63.89,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM63.98,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M67.28,207.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57ZM67.44,205.24l-.46-.02c0-.25.07-.46.22-.62.14-.16.32-.24.54-.24.09,0,.18.02.25.05.07.03.14.07.21.11.07.04.13.08.21.11s.15.05.24.05c.09,0,.17-.04.24-.11.07-.07.1-.16.1-.27l.45.04c0,.26-.07.46-.22.62-.14.15-.32.23-.54.23-.11,0-.21-.02-.28-.05-.08-.03-.14-.07-.2-.11-.06-.04-.12-.08-.18-.11s-.14-.05-.24-.05-.17.04-.23.11c-.06.07-.09.16-.09.27Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M72.32,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM72.32,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M77.63,206.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M81.22,202.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M84.4,209.52v-5.09h3.31v.77h-2.39v1.38h2.22v.77h-2.22v1.39h2.41v.77h-3.33Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M88.41,205.2v-.77h4.06v.77h-1.57v4.32h-.92v-4.32h-1.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M94.87,204.97v-.55h3.82v.55h-1.6v4.54h-.62v-4.54h-1.6Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M100.54,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM100.54,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M104.69,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM104.69,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M108.96,205.7v.5h-1.98v-.5h1.98ZM107.56,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.82,205.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM110.11,205.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M112.59,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM112.67,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M118.74,211.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM118.72,208.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M122.56,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM122.65,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M125.37,209.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M129.07,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM129.16,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M132.46,207.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M137.61,205.7v.5h-1.98v-.5h1.98ZM136.21,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M138.77,205.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM138.48,209.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M140.41,205.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM140.12,209.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M144.68,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM144.77,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M148.61,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM148.7,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M154.12,206.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M156.71,205.7v.5h-1.98v-.5h1.98ZM155.31,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M158.7,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM158.79,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M163.16,205.7v.5h-1.98v-.5h1.98ZM161.76,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M165.59,209.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M170.75,206.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M174.34,202.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M177.52,209.52v-5.09h3.26v.77h-2.34v1.38h2.12v.77h-2.12v2.16h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M182.52,204.43v5.09h-.92v-5.09h.92Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M185.15,204.97v-.55h3.82v.55h-1.6v4.54h-.62v-4.54h-1.6Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M191.71,207.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M194.9,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM194.9,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M199.16,205.7v.5h-1.98v-.5h1.98ZM197.76,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M201.69,205.7v.5h-1.98v-.5h1.98ZM200.29,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M203.67,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM203.76,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M206.48,205.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM206.77,205.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M209.24,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM209.33,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.63,207.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M219.58,205.7v.5h-1.98v-.5h1.98ZM218.18,204.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M221.57,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM221.66,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M224.38,209.52v-5.09h.59v5.09h-.59ZM224.92,208.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM226.8,209.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M230.57,207.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M234.61,207.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M241.18,205.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M244.34,207.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M247.53,209.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM247.53,209.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M252.84,206.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M254.07,205.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM253.77,209.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M256,207.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M260.61,209.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM260.7,209.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M7.71,211.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M11.91,218.52v-5.09h3.26v.77h-2.34v1.38h2.12v.77h-2.12v2.16h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M15.99,218.52v-5.09h1.91c.39,0,.72.07.99.2.27.14.47.33.6.57s.21.53.21.85-.07.61-.21.85c-.14.24-.34.42-.61.55-.27.13-.6.2-.99.2h-1.36v-.77h1.24c.23,0,.42-.03.56-.1.15-.06.25-.16.33-.28.07-.12.11-.28.11-.46s-.04-.33-.11-.46c-.07-.13-.18-.23-.33-.29-.15-.07-.33-.1-.56-.1h-.84v4.32h-.92ZM18.62,216.21l1.26,2.31h-1.03l-1.24-2.31h1.01Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M26.94,215.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.38-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.12.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.91-.19-.39-.28-.85-.28-1.39,0-.4.05-.77.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M29.69,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM29.78,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M32.49,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M36.2,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM36.29,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M39.59,216.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M44.74,214.7v.5h-1.98v-.5h1.98ZM43.33,213.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M45.9,214.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM45.6,218.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M48.84,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M55.56,218.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM55.64,218.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M60.85,216.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M65.32,219.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.18-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM65.89,216.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M69.56,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M73.58,218.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM73.58,218.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M77.62,218.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM77.7,218.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M82.91,216.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M86.1,218.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M90.1,214.7v.5h-1.98v-.5h1.98ZM88.7,213.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M92.52,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M97.39,216.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.02,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M106.04,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.08,216.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M116.52,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM116.61,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M119.91,216.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M123.98,216.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M129.07,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12ZM128.71,214.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M133.13,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M138.29,215.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M142.9,211.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M150.52,215.05c-.04-.13-.1-.25-.17-.36-.07-.11-.16-.2-.26-.28-.1-.08-.21-.13-.34-.17s-.27-.06-.42-.06c-.27,0-.52.07-.73.21s-.38.34-.5.61c-.12.27-.18.59-.18.97s.06.71.18.98.29.47.5.61c.21.14.47.21.75.21.26,0,.48-.05.67-.15s.34-.24.44-.42c.1-.18.15-.4.15-.64l.21.03h-1.38v-.72h2.07v.61c0,.44-.09.81-.28,1.13s-.44.56-.77.73c-.33.17-.7.26-1.12.26-.47,0-.88-.11-1.23-.32-.35-.21-.63-.51-.83-.9s-.3-.85-.3-1.39c0-.41.06-.78.17-1.1.12-.32.28-.6.49-.82.21-.23.46-.4.74-.52.28-.12.59-.18.92-.18.28,0,.54.04.79.12.24.08.46.2.65.35.19.15.35.33.47.54.12.21.2.44.24.69h-.94Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M152.87,218.52h-.98l1.79-5.09h1.14l1.79,5.09h-.98l-1.36-4.05h-.04l-1.36,4.05ZM152.9,216.52h2.68v.74h-2.68v-.74Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M160.2,218.52v-5.09h1.72c.4,0,.72.07.98.2.25.13.44.32.57.56s.18.5.18.8-.06.57-.18.8c-.12.23-.31.41-.56.55-.25.13-.58.2-.97.2h-1.39v-.56h1.37c.27,0,.49-.04.66-.12.17-.08.29-.19.36-.34.08-.15.11-.32.11-.53s-.04-.38-.11-.54c-.08-.15-.2-.27-.37-.35-.17-.08-.39-.13-.66-.13h-1.08v4.54h-.62ZM162.59,216.23l1.25,2.29h-.72l-1.23-2.29h.7Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M165.7,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM165.79,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM165.8,214.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M170.16,214.7v.5h-1.98v-.5h1.98ZM168.76,213.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M171.69,216.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47s.42-.17.72-.17c.26,0,.49.05.68.16s.35.26.46.47.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.71-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M176.34,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM176.43,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M179.14,218.52v-3.82h.59v3.82h-.59ZM179.17,214.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.34,218.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM182.34,218.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M186.49,218.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M189.41,216.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47s.42-.17.72-.17c.26,0,.49.05.68.16s.35.26.46.47.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.71-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M194.6,214.7v.5h-1.98v-.5h1.98ZM193.2,213.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M199.42,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM199.51,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M202.81,216.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M210.78,214.7v.5h-1.98v-.5h1.98ZM209.38,213.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.77,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM212.86,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM212.88,214.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M215.87,214.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM215.57,218.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M217.21,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M221.22,220.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM221.2,217.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M225.52,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M229.53,218.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM229.53,218.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M232.13,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M235.84,218.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM235.93,218.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M242.91,218.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM242.99,218.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M247.39,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M252.68,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M256.74,218.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12ZM256.38,214.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M259.5,214.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM259.2,218.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M260.84,218.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.93,227.52v-5.09h.59v1.88h.05c.04-.07.1-.15.18-.25.08-.1.19-.2.33-.28.14-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05c-.14.3-.33.52-.57.69-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12s-.26-.18-.34-.28c-.08-.11-.14-.19-.18-.26h-.07v.59h-.57ZM7.51,225.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.12-.47.12-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51s-.37-.19-.62-.19-.44.06-.6.18c-.16.12-.29.29-.37.5s-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M11.76,222.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M13.11,223.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM12.82,227.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M15.58,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM15.67,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M18.97,225.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M24.12,223.7v.5h-1.98v-.5h1.98ZM22.72,222.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M26.11,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM26.2,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M32.11,220.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M35.84,227.52v-5.09h.92v2.16h2.36v-2.16h.92v5.09h-.92v-2.16h-2.36v2.16h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M41.03,227.52v-5.09h1.91c.39,0,.72.07.99.2.27.14.47.33.6.57s.21.53.21.85-.07.61-.21.85c-.14.24-.34.42-.61.55-.27.13-.6.2-.99.2h-1.36v-.77h1.24c.23,0,.42-.03.56-.1.15-.06.25-.16.33-.28.07-.12.11-.28.11-.46s-.04-.33-.11-.46c-.07-.13-.18-.23-.33-.29-.15-.07-.33-.1-.56-.1h-.84v4.32h-.92ZM43.66,225.21l1.26,2.31h-1.03l-1.24-2.31h1.01Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M49.98,222.43h.62v3.64c0,.32-.06.6-.18.83-.12.23-.29.4-.5.52-.22.12-.47.18-.77.18-.28,0-.53-.05-.74-.15-.22-.1-.39-.25-.51-.44-.12-.19-.19-.41-.19-.67h.61c0,.14.04.27.11.38.07.11.17.19.3.25s.27.09.43.09c.18,0,.33-.04.45-.11s.22-.18.28-.33c.07-.15.1-.32.1-.53v-3.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M52.85,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM52.94,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M55.65,227.52v-3.82h.57v.6h.05c.08-.2.21-.36.39-.48.18-.11.39-.17.64-.17s.46.06.63.17.3.27.39.48h.04c.1-.2.25-.35.44-.47s.43-.17.7-.17c.34,0,.62.11.84.32s.33.54.33.99v2.55h-.59v-2.55c0-.28-.08-.48-.23-.6s-.34-.18-.54-.18c-.27,0-.48.08-.62.24-.15.16-.22.37-.22.61v2.49h-.6v-2.62c0-.22-.07-.39-.21-.53s-.32-.2-.54-.2c-.15,0-.29.04-.43.12s-.24.19-.32.34-.12.31-.12.5v2.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M64.42,224.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M67.01,223.7v.5h-1.98v-.5h1.98ZM65.61,222.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M71,223.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M73.17,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM73.17,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.12,228.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.18-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM78.7,225.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M82.37,227.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M86.38,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM86.38,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M89.28,223.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM88.99,227.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M90.51,227.52v-.45l2.17-2.78v-.04h-2.1v-.55h2.85v.47l-2.11,2.76v.04h2.18v.55h-2.99Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M97.51,223.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.68,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM99.68,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M103.73,227.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM103.81,227.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2ZM103.84,223.37v-.46h2.19v.46h-2.19Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M107.73,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM107.82,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M112.09,227.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7s.56-.25.9-.25c.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.14-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.23-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16ZM111.55,222.17l.52.7.52-.7h.56v.04l-.8,1.03h-.54l-.81-1.03v-.04h.56Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M115.54,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM115.63,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M123.1,225.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.13-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.11-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67.16.17.36.25.6.25.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M128.63,229.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28s-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27-.15.08-.34.12-.59.12-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64-.14-.28-.21-.62-.21-1.01s.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM128.62,226.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M132.89,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM132.89,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M136.93,227.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM137.01,227.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M140.11,223.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM139.82,227.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M142.04,225.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M146.65,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM146.74,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M149.46,227.52v-3.82h.57v.6h.05c.08-.2.21-.36.39-.48.18-.11.39-.17.64-.17s.46.06.63.17.3.27.39.48h.04c.1-.2.25-.35.44-.47s.43-.17.7-.17c.34,0,.62.11.84.32s.33.54.33.99v2.55h-.59v-2.55c0-.28-.08-.48-.23-.6s-.34-.18-.54-.18c-.27,0-.48.08-.62.24-.15.16-.22.37-.22.61v2.49h-.6v-2.62c0-.22-.07-.39-.21-.53s-.32-.2-.54-.2c-.15,0-.29.04-.43.12s-.24.19-.32.34-.12.31-.12.5v2.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M156.64,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM156.73,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M162.65,220.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M166.38,227.52v-5.09h.92v2.16h2.36v-2.16h.92v5.09h-.92v-2.16h-2.36v2.16h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M174.78,222.43h.92v3.33c0,.36-.09.69-.26.96-.17.28-.41.49-.72.65-.31.16-.67.23-1.09.23s-.78-.08-1.09-.23c-.31-.15-.55-.37-.72-.65-.17-.28-.26-.6-.26-.96v-3.33h.92v3.25c0,.21.05.4.14.57.09.17.23.3.4.39.17.09.37.14.61.14s.44-.05.61-.14c.17-.09.3-.22.4-.39.09-.17.14-.35.14-.57v-3.25Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.63,224.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.38-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.12.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.91-.19-.39-.28-.85-.28-1.39,0-.4.05-.77.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M184.63,228.95c-.1,0-.19,0-.27-.02-.08-.02-.13-.03-.16-.05l.15-.52c.14.04.27.05.38.04.11,0,.21-.06.29-.14.08-.09.16-.23.23-.42l.11-.3-1.41-3.84h.64l1.05,3.04h.04l1.05-3.04h.64l-1.62,4.38c-.07.2-.16.36-.27.49-.11.13-.23.23-.37.29-.14.06-.3.09-.48.09Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M189.13,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM189.22,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM189.24,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M191.93,227.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M196.41,223.7v.5h-1.98v-.5h1.98ZM195.01,222.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M198.79,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM198.79,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2ZM198.52,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M201.69,223.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM201.39,227.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M205.38,223.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM205.67,223.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M208.57,227.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.75.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM208.57,227.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.39.38.53c.17.13.38.2.65.2ZM208.31,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.84,223.7v.5h-1.98v-.5h1.98ZM211.44,222.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11s-.29-.18-.39-.33c-.1-.15-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M214.83,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM214.92,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM214.94,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M218.22,222.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M219.86,222.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M222.03,227.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.23-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM222.12,227.08c.23,0,.43-.04.59-.14.16-.09.28-.21.36-.35.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08-.18.04-.29.06c-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM222.14,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M227.54,224.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46.15.1.34.15.58.15.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33s-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M232.42,227.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12ZM232.07,223.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M237.88,223.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M240.1,227.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M242.55,227.52v-5.09h.59v5.09h-.59ZM243.1,226.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM244.98,227.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M246.42,227.52v-5.09h.59v1.88h.05c.04-.07.1-.15.18-.25.08-.1.19-.2.33-.28.14-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05c-.14.3-.33.52-.57.69-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12s-.26-.18-.34-.28c-.08-.11-.14-.19-.18-.26h-.07v.59h-.57ZM247,225.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.12-.47.12-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51s-.37-.19-.62-.19-.44.06-.6.18c-.16.12-.29.29-.37.5s-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M252.27,227.6c-.37,0-.68-.08-.95-.25-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.15-.32.26-.52.34-.21.08-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M255.31,225.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M262,220.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M7.74,231.43v5.09h-.92v-5.09h.92Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M8.5,232.2v-.77h4.06v.77h-1.57v4.32h-.92v-4.32h-1.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M18.55,233.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.38-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.77.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M21.29,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM21.38,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M24.1,236.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M27.8,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM27.89,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M31.19,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M34.57,236.52v-.45l2.17-2.78v-.04h-2.1v-.55h2.85v.47l-2.11,2.76v.04h2.18v.55h-2.99Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M38.75,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM38.45,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M41.21,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM41.3,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M47.31,236.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM47.39,236.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M51.8,236.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M54.84,231.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M57.75,237.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.3.21.64.21,1.04s-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM58.32,234.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M61.99,236.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M66.01,236.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM66.01,236.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M70.05,236.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04c.14-.29.33-.52.57-.68.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM70.13,236.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.53-.12-.75-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M75.34,234.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.64,232.7v.5h-1.98v-.5h1.98ZM77.24,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M81.17,232.7v.5h-1.98v-.5h1.98ZM79.76,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M83.54,236.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM83.54,236.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M86.15,236.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M90.21,236.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M94.82,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM94.52,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M96.75,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M103.22,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM103.31,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M106.61,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M110.68,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M114.47,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM114.17,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M118.52,229.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M121.76,236.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M124.83,232.2v-.77h4.06v.77h-1.57v4.32h-.92v-4.32h-1.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M135.1,233.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.38-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.77.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M137.84,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM137.93,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M140.65,236.52v-3.82h.57v.6h.05c.08-.2.21-.36.39-.48.18-.11.39-.17.64-.17s.46.06.63.17.3.27.39.48h.04c.1-.2.25-.35.44-.47s.43-.17.7-.17c.34,0,.62.11.84.32s.33.54.33.99v2.55h-.59v-2.55c0-.28-.08-.48-.23-.6s-.34-.18-.54-.18c-.27,0-.48.08-.62.24-.15.16-.22.37-.22.61v2.49h-.6v-2.62c0-.22-.07-.39-.21-.53s-.32-.2-.54-.2c-.15,0-.29.04-.43.12s-.24.19-.32.34-.12.31-.12.5v2.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M147.01,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM146.71,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M148.93,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M154.08,232.7v.5h-1.98v-.5h1.98ZM152.68,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M156.46,236.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM156.46,236.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M159.06,232.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM159.35,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M162.25,236.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM162.25,236.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M168.26,238.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28-.13-.12-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27s-.34.12-.59.12c-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64s-.21-.62-.21-1.01.07-.73.21-1.02c.14-.29.33-.52.57-.68s.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM168.24,235.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73-.21-.38-.37-.5c-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51s-.12.45-.12.71.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M172.08,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM172.17,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M174.88,236.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32s-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M178.59,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM178.68,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M181.98,234.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M187.13,232.7v.5h-1.98v-.5h1.98ZM185.73,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M188.29,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM188,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M189.64,232.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM189.92,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M192.4,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM192.49,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M197.06,236.52v-3.82h.57v.6h.05c.08-.2.21-.36.39-.48.18-.11.39-.17.64-.17s.46.06.63.17.3.27.39.48h.04c.1-.2.25-.35.44-.47s.43-.17.7-.17c.34,0,.62.11.84.32s.33.54.33.99v2.55h-.59v-2.55c0-.28-.08-.48-.23-.6s-.34-.18-.54-.18c-.27,0-.48.08-.62.24-.15.16-.22.37-.22.61v2.49h-.6v-2.62c0-.22-.07-.39-.21-.53s-.32-.2-.54-.2c-.15,0-.29.04-.43.12s-.24.19-.32.34-.12.31-.12.5v2.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M204.72,236.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7s.56-.25.9-.25c.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59s.14.54.14.9v.25h-2.94v-.51h2.35c0-.22-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M208.84,232.7v.5h-1.98v-.5h1.98ZM207.44,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M210.83,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM210.92,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M213.93,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12ZM213.63,236.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M217.97,233.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.16.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46s.34.15.58.15c.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33-.09-.09-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.22.06-.41.18-.57.12-.17.29-.3.5-.39.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M221.62,229.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M224.85,236.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M228.95,231.43l1.32,4.01h.05l1.32-4.01h1.01l-1.79,5.09h-1.14l-1.79-5.09h1.01Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M235.29,236.52v-5.09h1.72c.4,0,.72.07.98.2.25.13.44.32.57.56s.18.5.18.8-.06.57-.18.8c-.12.23-.31.41-.56.54-.25.13-.58.2-.97.2h-1.39v-.56h1.37c.27,0,.49-.04.66-.12.17-.08.29-.19.36-.34.08-.15.11-.32.11-.53s-.04-.38-.11-.54c-.08-.15-.2-.27-.37-.35-.17-.08-.39-.13-.66-.13h-1.08v4.54h-.62ZM237.68,234.23l1.25,2.29h-.72l-1.23-2.29h.7Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M240.78,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM240.87,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M243.48,236.52v-.45l2.17-2.78v-.04h-2.1v-.55h2.85v.47l-2.11,2.76v.04h2.18v.55h-2.99ZM244.42,231.17l.52.7.52-.7h.56v.04l-.81,1.03h-.54l-.81-1.03v-.04h.56Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M248.79,236.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM248.79,236.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M253.06,232.7v.5h-1.98v-.5h1.98ZM251.66,231.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M255.05,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM256.59,231.43v.5h-2.33v-.5h2.33ZM255.14,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M257.85,232.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM258.14,232.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28.18-.12.29-.12.21.04.29.12.12.17.12.28-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M260.61,236.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM260.7,236.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M8.39,247.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28-.13-.12-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27s-.34.12-.59.12c-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64s-.21-.62-.21-1.01.07-.73.21-1.02.33-.52.57-.68.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM8.38,244.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51-.08.21-.12.45-.12.71s.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M12.22,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM12.31,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M15.02,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M18.73,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM18.82,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M22.12,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M27.27,241.7v.5h-1.98v-.5h1.98ZM25.87,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M28.43,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM28.14,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M29.77,241.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM30.06,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M32.54,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM32.63,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M38.52,247.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28-.13-.12-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27s-.34.12-.59.12c-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64s-.21-.62-.21-1.01.07-.73.21-1.02.33-.52.57-.68.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM38.5,244.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51-.08.21-.12.45-.12.71s.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M42.35,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM42.44,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M46.59,245.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM46.67,245.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M51.03,245.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM51.03,245.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M56.34,242.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.15.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46s.34.15.58.15c.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33-.09-.09-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.21.06-.41.18-.57s.29-.3.5-.39c.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M59.76,238.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M62.78,240.43h1.13l1.51,3.69h.06l1.51-3.69h1.13v5.09h-.88v-3.5h-.05l-1.41,3.48h-.66l-1.41-3.49h-.05v3.5h-.88v-5.09Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M68.88,241.2v-.77h4.06v.77h-1.57v4.32h-.92v-4.32h-1.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.94,242.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.39-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.76.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M81.68,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM81.77,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M84.48,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M88.19,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM88.28,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M91.58,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M94.96,245.52v-.45l2.17-2.78v-.04h-2.1v-.55h2.85v.47l-2.11,2.76v.04h2.18v.55h-2.99Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.13,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM98.84,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M100.48,241.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM100.76,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M103.24,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM103.33,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.34,241.7v.5h-1.98v-.5h1.98ZM107.94,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M111.33,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM111.42,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M114.72,240.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M117.96,243.06v.55h-2.23v-.55h2.23Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M118.97,246.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68s.21.64.21,1.04-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM119.55,243.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M123.22,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M127.23,245.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM127.23,245.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M131.28,245.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM131.36,245.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M136.57,243.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M139.87,241.7v.5h-1.98v-.5h1.98ZM138.47,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M142.39,241.7v.5h-1.98v-.5h1.98ZM140.99,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M145.66,243.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M147.3,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M153.23,241.7v.5h-2.06v-.5h2.06ZM151.79,245.52v-4.34c0-.22.05-.4.15-.55.1-.15.24-.26.4-.33.16-.07.34-.11.52-.11.14,0,.26.01.35.03.09.02.16.04.2.06l-.17.51s-.07-.02-.12-.04c-.05-.01-.12-.02-.21-.02-.19,0-.33.05-.42.15-.08.1-.13.24-.13.43v4.21h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M154.33,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM154.03,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M160.02,242.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.15.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46s.34.15.58.15c.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33-.09-.09-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.21.06-.41.18-.57s.29-.3.5-.39c.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M161.54,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M165.32,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM165.03,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M167.25,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M173.24,238.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M180.44,240.43v5.09h-.82l-2.4-3.47h-.04v3.47h-.92v-5.09h.83l2.4,3.47h.04v-3.47h.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M181.42,245.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M187.11,245.52v-5.09h1.72c.4,0,.73.07.98.21.25.14.44.34.57.58.12.24.18.52.18.82s-.06.57-.18.82c-.12.25-.31.44-.56.58-.25.15-.58.22-.97.22h-1.23v-.55h1.21c.27,0,.49-.05.66-.14s.29-.22.36-.38c.08-.16.11-.34.11-.55s-.04-.39-.11-.55c-.08-.16-.2-.29-.36-.38-.17-.09-.39-.14-.67-.14h-1.08v4.54h-.62Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M191.46,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M195.47,245.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM195.47,245.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M199.52,245.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM199.6,245.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M204.81,243.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M208,245.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M211.93,245.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M214.98,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M220.13,241.7v.5h-1.98v-.5h1.98ZM218.72,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M222.55,245.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M225.59,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M230.62,247.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28-.13-.12-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27s-.34.12-.59.12c-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64s-.21-.62-.21-1.01.07-.73.21-1.02.33-.52.57-.68.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM230.6,244.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51-.08.21-.12.45-.12.71s.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M234.45,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM234.54,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M237.25,245.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M240.96,245.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM241.05,245.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M244.35,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M249.5,241.7v.5h-1.98v-.5h1.98ZM248.1,240.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M250.66,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM250.36,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M253.6,245.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M258,241.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM257.7,245.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M259.93,243.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.85,250.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM7.14,250.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M9.62,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM9.71,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M12.42,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M16.48,254.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M19.53,252.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M25.82,247.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M29.14,254.52v-5.09h1.91c.39,0,.72.07.99.22.27.15.47.35.6.6.14.25.21.54.21.87s-.07.62-.21.87c-.14.25-.34.45-.61.6-.27.14-.6.22-.99.22h-1.26v-.76h1.14c.23,0,.42-.04.56-.12.15-.08.25-.19.33-.33.07-.14.11-.3.11-.48s-.04-.34-.11-.48c-.07-.14-.18-.25-.33-.32s-.33-.12-.57-.12h-.84v4.32h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M33.63,254.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M43.11,251.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.39-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.76.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M45.59,254.52l-1.16-3.82h.62l.83,2.92h.04l.82-2.92h.63l.81,2.91h.04l.83-2.91h.62l-1.16,3.82h-.58l-.83-2.93h-.06l-.83,2.93h-.58Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M51.52,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM51.61,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M54.32,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M58.03,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM58.12,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M61.42,252.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M66.46,254.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M68.79,250.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM69.08,250.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M71.56,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM71.65,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M76.31,255.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68s.21.64.21,1.04-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM76.88,252.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M80.55,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M84.57,254.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM84.57,254.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M88.61,254.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM88.69,254.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M93.9,252.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M97.09,254.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M101.03,254.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M104.07,252.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.22,250.7v.5h-1.98v-.5h1.98ZM107.82,249.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M111.21,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM111.3,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M116.82,254.52l-1.16-3.82h.62l.83,2.92h.04l.82-2.92h.63l.81,2.91h.04l.83-2.91h.62l-1.16,3.82h-.58l-.83-2.93h-.06l-.83,2.93h-.58Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M124.16,249.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M126.33,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM126.42,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M130.8,250.7v.5h-1.98v-.5h1.98ZM129.4,249.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M132.79,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM132.88,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M137.14,254.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M140.06,252.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47.18-.12.42-.18.72-.18.26,0,.49.05.68.16s.35.26.46.48.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.7-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M146.39,247.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M149.72,254.52v-5.09h1.91c.39,0,.72.07.99.22.27.15.47.35.6.6.14.25.21.54.21.87s-.07.62-.21.87c-.14.25-.34.45-.61.6-.27.14-.6.22-.99.22h-1.26v-.76h1.14c.23,0,.42-.04.56-.12.15-.08.25-.19.33-.33.07-.14.11-.3.11-.48s-.04-.34-.11-.48c-.07-.14-.18-.25-.33-.32s-.33-.12-.57-.12h-.84v4.32h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M153.98,250.2v-.77h4.06v.77h-1.57v4.32h-.92v-4.32h-1.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M164.34,251.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.39-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.76.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M167.08,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM167.17,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M169.88,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M173.59,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM173.68,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M176.98,252.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M182.13,250.7v.5h-1.98v-.5h1.98ZM180.73,249.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M183.29,250.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM183,254.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M185.76,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM185.85,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M191.95,254.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM192.03,254.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M196.38,254.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM196.38,254.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M200.94,255.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68s.21.64.21,1.04-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM201.51,252.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M205.18,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M209.2,254.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM209.2,254.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M213.24,254.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM213.32,254.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M218.53,252.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M221.83,250.7v.5h-1.98v-.5h1.98ZM220.43,249.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M224.21,254.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM224.21,254.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M226.81,254.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M232.94,254.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M235.4,254.52v-3.82h.57v.6h.05c.08-.2.21-.36.39-.48.18-.11.39-.17.64-.17s.46.06.63.17c.17.11.3.27.39.48h.04c.1-.2.25-.35.44-.47.2-.12.43-.18.7-.18.34,0,.62.11.84.32s.33.54.33.99v2.56h-.59v-2.56c0-.28-.08-.48-.23-.6s-.34-.18-.54-.18c-.27,0-.48.08-.62.24-.15.16-.22.37-.22.61v2.49h-.6v-2.62c0-.22-.07-.39-.21-.53-.14-.13-.32-.2-.54-.2-.15,0-.29.04-.43.12s-.24.19-.32.34c-.08.14-.12.31-.12.5v2.39h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M244.53,254.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM244.62,254.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M247.92,252.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M252.96,254.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM252.96,254.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M258.27,251.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.15.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46s.34.15.58.15c.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33-.09-.09-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.21.06-.41.18-.57s.29-.3.5-.39c.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M262.01,247.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.82,263.52v-5.09h1.91c.39,0,.72.07.99.2.27.14.47.33.6.57s.21.53.21.85-.07.61-.21.85c-.14.24-.34.42-.61.55-.27.13-.6.2-.99.2h-1.36v-.77h1.24c.23,0,.42-.03.56-.1.15-.06.25-.16.33-.28.07-.12.11-.28.11-.46s-.04-.33-.11-.46c-.07-.13-.18-.23-.33-.29-.15-.07-.33-.1-.56-.1h-.84v4.32h-.92ZM9.45,261.21l1.26,2.31h-1.03l-1.24-2.31h1.01Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M15.9,260.97c0,.55-.1,1.02-.31,1.41-.21.39-.48.69-.83.9-.35.21-.75.31-1.2.31s-.84-.1-1.2-.31c-.35-.21-.63-.51-.83-.9-.2-.39-.31-.86-.31-1.41s.1-1.02.31-1.41c.21-.39.48-.69.83-.9.35-.21.75-.31,1.2-.31s.84.1,1.2.31c.35.21.63.51.83.9.21.39.31.86.31,1.41ZM14.97,260.97c0-.39-.06-.71-.18-.98-.12-.27-.29-.47-.5-.6s-.46-.21-.73-.21-.52.07-.73.21-.38.34-.5.6c-.12.27-.18.59-.18.98s.06.71.18.98.29.47.5.6.46.21.73.21.52-.07.73-.21.38-.34.5-.6.18-.59.18-.98Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M22.45,260.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.39-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.76.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M25.19,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM25.28,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M27.99,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M31.7,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM31.79,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M35.09,261.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M40.24,259.7v.5h-1.98v-.5h1.98ZM38.84,258.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8ZM38.88,265.21l.28-1.29h.6l-.42,1.29h-.46Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M41.4,259.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM41.11,263.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M43.87,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM43.96,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M48.77,264.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68s.21.64.21,1.04-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM49.35,261.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M53.01,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M57.03,263.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM57.03,263.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M61.08,263.6c-.32,0-.6-.08-.84-.24-.24-.16-.43-.39-.57-.69s-.21-.65-.21-1.05.07-.75.21-1.04.33-.52.57-.68c.25-.16.53-.24.85-.24.25,0,.45.04.59.12.14.08.26.17.33.28s.14.19.18.25h.05v-1.88h.59v5.09h-.57v-.59h-.07c-.04.07-.1.16-.18.26-.08.11-.19.2-.34.28s-.34.12-.59.12ZM61.16,263.07c.24,0,.43-.06.6-.19.16-.12.29-.29.37-.51.08-.22.13-.47.13-.76s-.04-.54-.12-.75c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.3-.37.51-.08.22-.12.46-.12.73s.04.52.13.74c.08.22.21.4.37.53.16.13.37.2.62.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M66.37,261.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M69.55,263.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M73.01,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM73.1,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM73.88,258.43h.55c0,.27-.09.49-.28.66-.19.17-.44.26-.76.26s-.56-.09-.75-.26c-.18-.17-.28-.39-.28-.66h.55c0,.13.04.24.11.34s.2.15.37.15.3-.05.37-.15c.08-.1.11-.21.11-.34Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M77.48,259.7v.5h-1.98v-.5h1.98ZM76.08,258.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M79.85,263.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM79.85,263.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M82.46,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M87.45,261.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M89.67,258.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M93.13,261.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M95.07,259.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM94.77,263.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.32,259.24l-.52-.7-.52.7h-.56v-.04l.8-1.03h.54l.81,1.03v.04h-.56ZM98.51,263.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M100.74,261.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M107.45,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM107.54,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M110.84,261.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M114.62,259.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM114.33,263.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M118.92,256.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M125.16,259.83c-.02-.22-.12-.39-.29-.51-.17-.12-.39-.18-.67-.18-.19,0-.36.03-.5.09s-.24.14-.32.24-.11.21-.11.34c0,.11.02.2.07.28s.12.14.2.2c.08.05.18.1.28.14.1.04.21.07.31.09l.48.12c.19.04.38.1.56.18.18.08.34.17.48.29.14.12.25.26.34.42s.12.36.12.58c0,.3-.08.56-.23.79s-.37.4-.66.53c-.29.13-.63.19-1.04.19s-.74-.06-1.03-.18c-.29-.12-.52-.3-.68-.54s-.25-.52-.26-.86h.91c.01.18.07.33.16.44.1.12.22.21.38.26.15.06.33.09.52.09s.38-.03.53-.09c.15-.06.27-.14.36-.25.09-.11.13-.24.13-.38,0-.13-.04-.24-.12-.33-.08-.09-.18-.16-.32-.22-.14-.06-.3-.11-.48-.16l-.58-.15c-.42-.11-.75-.27-.99-.49-.24-.22-.36-.51-.36-.88,0-.3.08-.56.25-.79s.39-.4.67-.53c.28-.12.6-.19.96-.19s.68.06.95.19.49.3.64.52c.16.22.24.47.24.76h-.89Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M126.92,263.52v-5.09h.92v2.34h.06l1.99-2.34h1.13l-1.97,2.28,1.99,2.81h-1.11l-1.52-2.18-.56.67v1.52h-.92Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M133.68,263.52v-.45l2.74-4.1h-2.77v-.55h3.51v.45l-2.74,4.1h2.77v.55h-3.51Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M139.25,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM139.34,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM139.36,259.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M142.05,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M147.04,261.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M148.68,263.52v-5.09h.59v5.09h-.59ZM149.23,262.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM151.11,263.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M153.59,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM153.68,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M161.62,259.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M162.75,264.95c-.1,0-.19,0-.27-.02-.08-.02-.13-.03-.16-.05l.15-.52c.14.04.27.05.38.04s.21-.06.29-.15c.08-.09.16-.23.23-.42l.11-.3-1.41-3.84h.64l1.05,3.04h.04l1.05-3.04h.64l-1.62,4.38c-.07.2-.16.36-.27.49-.11.13-.23.23-.37.29-.14.06-.3.09-.48.09ZM163.51,259.18l.61-1.15h.69l-.78,1.15h-.52Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M166.25,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M170.26,263.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM170.26,263.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M172.95,263.52v-5.09h.59v1.88h.05c.04-.07.1-.15.18-.25.08-.1.19-.2.33-.28.14-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68.14.29.21.64.21,1.04s-.07.75-.21,1.05c-.14.3-.33.52-.57.69-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12s-.26-.17-.34-.28c-.08-.11-.14-.19-.18-.26h-.07v.59h-.57ZM173.52,261.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.12-.47.12-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.17-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M178.74,263.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M183.48,261.96v-2.26h.59v3.82h-.59v-.65h-.04c-.09.19-.23.36-.42.49-.19.14-.43.2-.72.2-.24,0-.45-.05-.64-.16-.19-.1-.33-.26-.44-.48-.11-.21-.16-.48-.16-.81v-2.43h.59v2.39c0,.28.08.5.23.67s.36.25.6.25c.15,0,.29-.04.45-.11.15-.07.28-.19.38-.34s.16-.35.16-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M190.34,259.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M193.2,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M197.21,263.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM197.21,263.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M199.82,263.52v-5.09h.59v5.09h-.59ZM200.36,262.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM202.24,263.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M205,263.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM205,263.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M209.15,263.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M212.07,261.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47.18-.12.42-.18.72-.18.26,0,.49.05.68.16s.35.26.46.48.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.7-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M218.56,256.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M224.8,259.83c-.02-.22-.12-.39-.29-.51-.17-.12-.39-.18-.67-.18-.19,0-.36.03-.5.09s-.24.14-.32.24-.11.21-.11.34c0,.11.02.2.07.28s.12.14.2.2c.08.05.18.1.28.14.1.04.21.07.31.09l.48.12c.19.04.38.1.56.18.18.08.34.17.48.29.14.12.25.26.34.42s.12.36.12.58c0,.3-.08.56-.23.79s-.37.4-.66.53c-.29.13-.63.19-1.04.19s-.74-.06-1.03-.18c-.29-.12-.52-.3-.68-.54s-.25-.52-.26-.86h.91c.01.18.07.33.16.44.1.12.22.21.38.26.15.06.33.09.52.09s.38-.03.53-.09c.15-.06.27-.14.36-.25.09-.11.13-.24.13-.38,0-.13-.04-.24-.12-.33-.08-.09-.18-.16-.32-.22-.14-.06-.3-.11-.48-.16l-.58-.15c-.42-.11-.75-.27-.99-.49-.24-.22-.36-.51-.36-.88,0-.3.08-.56.25-.79s.39-.4.67-.53c.28-.12.6-.19.96-.19s.68.06.95.19.49.3.64.52c.16.22.24.47.24.76h-.89Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M226.55,263.52v-5.09h.92v4.32h2.24v.77h-3.17Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M236.19,260.02c-.05-.17-.13-.32-.21-.45-.09-.13-.19-.25-.32-.34-.12-.09-.26-.17-.41-.22-.15-.05-.32-.08-.51-.08-.3,0-.58.08-.82.23-.25.16-.44.39-.59.69-.15.3-.22.67-.22,1.12s.07.81.22,1.12c.15.3.35.53.6.69.25.16.54.23.85.23.29,0,.55-.06.77-.19.22-.13.4-.3.52-.53s.19-.5.19-.81l.19.04h-1.53v-.55h1.94v.55c0,.42-.09.78-.27,1.09-.18.31-.42.55-.74.72s-.67.25-1.08.25c-.45,0-.85-.11-1.19-.32-.34-.21-.61-.51-.8-.9-.19-.39-.28-.86-.28-1.39,0-.4.05-.76.16-1.09s.26-.6.46-.82c.2-.23.43-.4.71-.52.27-.12.57-.18.9-.18.27,0,.52.04.75.12.23.08.44.19.62.34.18.15.34.32.46.52.12.2.21.43.25.67h-.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M238.93,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM239.02,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M241.74,263.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M245.44,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM245.53,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M248.83,261.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M253.87,263.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M256.51,259.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM256.21,263.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M257.85,259.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM258.13,259.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M260.61,263.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM260.7,263.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M6.85,273.95v-5.25h.57v.61h.07c.04-.07.1-.15.18-.25s.19-.2.33-.28c.15-.08.34-.12.59-.12.32,0,.6.08.85.24.25.16.44.39.57.68s.21.64.21,1.04-.07.75-.21,1.05-.33.52-.57.69c-.24.16-.52.24-.84.24-.25,0-.44-.04-.59-.12-.15-.08-.26-.17-.34-.28-.08-.11-.14-.19-.18-.26h-.05v2.02h-.59ZM7.43,270.61c0,.29.04.54.13.76.08.22.21.39.37.51.16.12.36.19.6.19s.45-.07.62-.2.29-.31.37-.53c.08-.22.13-.47.13-.74s-.04-.51-.12-.73c-.08-.22-.21-.39-.37-.51-.16-.13-.37-.19-.62-.19s-.44.06-.6.18c-.16.12-.29.29-.37.5-.08.21-.12.46-.12.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M11.1,272.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M15.11,272.6c-.34,0-.65-.08-.91-.25-.26-.16-.46-.39-.61-.69-.14-.29-.22-.64-.22-1.03s.07-.74.22-1.04c.15-.3.35-.53.61-.69.26-.16.56-.25.91-.25s.65.08.91.25.46.39.61.69c.15.3.22.64.22,1.04s-.07.74-.22,1.03c-.14.29-.35.52-.61.69s-.56.25-.91.25ZM15.11,272.07c.26,0,.48-.07.65-.2.17-.13.29-.31.38-.53s.12-.46.12-.71-.04-.49-.12-.71-.21-.4-.38-.53-.38-.2-.65-.2-.48.07-.65.2-.29.31-.38.53-.12.46-.12.71.04.49.12.71.21.4.38.53c.17.13.38.2.65.2Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M18.02,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM17.72,272.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M19.25,272.52v-.45l2.17-2.78v-.04h-2.1v-.55h2.85v.47l-2.11,2.76v.04h2.18v.55h-2.99Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M26.25,268.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M28.01,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM28.09,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M30.81,268.7h.59v4.1c0,.24-.04.44-.12.61-.08.17-.2.31-.36.4-.16.09-.36.14-.61.14h-.12v-.55h.11c.18,0,.31-.05.39-.16.08-.11.12-.25.12-.45v-4.1ZM31.1,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M33.57,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM33.66,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M36.96,267.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M39.56,272.6c-.36,0-.67-.08-.92-.25-.26-.17-.46-.4-.6-.7-.14-.3-.21-.64-.21-1.02s.07-.73.21-1.03c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.27,0,.51.05.73.15.22.1.39.24.53.42.14.18.22.39.26.63h-.59c-.04-.17-.14-.33-.3-.46-.15-.13-.36-.2-.62-.2-.23,0-.43.06-.6.18-.17.12-.3.29-.4.5-.1.21-.14.47-.14.75s.05.55.14.77.23.39.4.51c.17.12.37.18.61.18.15,0,.29-.03.42-.08.12-.05.23-.13.32-.23.09-.1.15-.22.18-.36h.59c-.03.22-.12.43-.25.61s-.3.32-.51.43-.46.16-.74.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M43.02,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM43.11,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M50.89,268.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M54.18,267.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M56.84,272.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M60.95,268.7v.5h-1.98v-.5h1.98ZM59.55,267.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M62.12,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM61.82,272.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M64.04,270.22v2.3h-.59v-5.09h.59v1.87h.05c.09-.2.22-.35.4-.47.18-.12.42-.18.72-.18.26,0,.49.05.68.16s.35.26.46.48.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.54-.23-.7-.16-.17-.37-.25-.65-.25-.19,0-.36.04-.52.12-.15.08-.27.2-.36.36-.09.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M70.37,265.79v8.37h-.5v-8.37h.5Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M76.46,268.83c-.02-.22-.12-.39-.29-.51-.17-.12-.39-.18-.67-.18-.19,0-.36.03-.5.09s-.24.14-.32.24-.11.21-.11.34c0,.11.02.2.07.28s.12.14.2.2c.08.05.18.1.28.14.1.04.21.07.31.09l.48.12c.19.04.38.1.56.18.18.08.34.17.48.29.14.12.25.26.34.42s.12.36.12.58c0,.3-.08.56-.23.79s-.37.4-.66.53c-.29.13-.63.19-1.04.19s-.74-.06-1.03-.18c-.29-.12-.52-.3-.68-.54s-.25-.52-.26-.86h.91c.01.18.07.33.16.44.1.12.22.21.38.26.15.06.33.09.52.09s.38-.03.53-.09c.15-.06.27-.14.36-.25.09-.11.13-.24.13-.38,0-.13-.04-.24-.12-.33-.08-.09-.18-.16-.32-.22-.14-.06-.3-.11-.48-.16l-.58-.15c-.42-.11-.75-.27-.99-.49-.24-.22-.36-.51-.36-.88,0-.3.08-.56.25-.79s.39-.4.67-.53c.28-.12.6-.19.96-.19s.68.06.95.19.49.3.64.52c.16.22.24.47.24.76h-.89Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M78.9,267.43l1.32,4.01h.05l1.32-4.01h1.01l-1.79,5.09h-1.14l-1.79-5.09h1.01Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d: "M85.05,267.97v-.55h3.82v.55h-1.6v4.54h-.62v-4.54h-1.6Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M90.02,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM89.72,272.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M91.95,267.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M93.59,267.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M97.76,268.7l-1.41,3.82h-.6l-1.41-3.82h.64l1.05,3.04h.04l1.05-3.04h.64Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M99.98,272.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M102.43,272.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M105.02,272.52v-5.09h.59v5.09h-.59ZM105.56,271.13v-.73s.11,0,.11,0l1.67-1.7h.73l-1.78,1.8h-.05l-.68.63ZM107.44,272.52l-1.49-1.89.42-.41,1.82,2.3h-.75Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M109.93,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM110.02,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M112.73,272.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M116.8,272.6c-.37,0-.68-.08-.95-.24-.27-.16-.47-.39-.61-.69-.14-.29-.21-.64-.21-1.03s.07-.74.21-1.04c.14-.3.34-.53.6-.7.26-.17.56-.25.9-.25.2,0,.4.03.59.1.19.07.37.17.53.32.16.15.29.34.38.59.09.24.14.54.14.9v.25h-2.94v-.51h2.35c0-.21-.04-.41-.13-.58s-.21-.3-.36-.4c-.16-.1-.34-.15-.55-.15-.23,0-.44.06-.61.17s-.3.26-.39.45c-.09.18-.14.38-.14.59v.34c0,.29.05.53.15.73.1.2.24.35.42.46s.39.16.62.16c.15,0,.29-.02.42-.07s.23-.11.32-.2.16-.2.21-.33l.57.16c-.06.19-.16.36-.3.51-.14.14-.32.26-.52.34s-.44.12-.7.12Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M119.84,270.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M126.03,269.55l-.53.15c-.03-.09-.08-.17-.15-.26-.06-.08-.15-.15-.26-.21s-.25-.08-.42-.08c-.23,0-.43.05-.58.16-.16.11-.23.24-.23.41,0,.15.05.26.16.35.11.08.27.15.5.21l.57.14c.34.08.6.21.76.38.17.17.25.39.25.66,0,.22-.06.41-.19.59-.12.17-.3.31-.52.41-.22.1-.48.15-.78.15-.39,0-.71-.08-.97-.25s-.42-.42-.48-.74l.56-.14c.05.21.15.36.3.46s.34.15.58.15c.27,0,.49-.06.65-.17.16-.12.24-.26.24-.42,0-.13-.05-.24-.14-.33-.09-.09-.24-.16-.43-.2l-.64-.15c-.35-.08-.61-.21-.77-.39-.16-.17-.25-.39-.25-.66,0-.21.06-.41.18-.57s.29-.3.5-.39c.21-.09.45-.14.72-.14.38,0,.67.08.89.25.22.17.37.38.46.66Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M130.46,274.03c-.28,0-.53-.04-.73-.11-.2-.07-.37-.17-.51-.28-.13-.12-.24-.24-.32-.37l.47-.33c.05.07.12.15.2.24.08.09.19.17.33.24.14.07.33.1.56.1.31,0,.56-.07.76-.22.2-.15.3-.38.3-.7v-.78h-.05c-.04.07-.1.16-.18.26-.08.1-.19.19-.34.27s-.34.12-.59.12c-.31,0-.58-.07-.83-.22-.24-.15-.44-.36-.58-.64s-.21-.62-.21-1.01.07-.73.21-1.02.33-.52.57-.68.53-.24.85-.24c.25,0,.45.04.59.12.15.08.26.17.34.28.08.1.14.19.18.25h.06v-.61h.57v3.93c0,.33-.07.6-.22.8s-.35.36-.6.46c-.25.1-.53.15-.83.15ZM130.44,271.93c.24,0,.43-.05.6-.16.16-.11.29-.26.37-.46.08-.2.13-.44.13-.73s-.04-.52-.12-.73c-.08-.21-.21-.38-.37-.5-.16-.12-.36-.18-.6-.18s-.46.06-.62.19c-.17.13-.29.29-.37.51-.08.21-.12.45-.12.71s.04.5.13.7c.08.2.21.36.37.48.16.12.37.17.62.17Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M134.28,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM134.37,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M137.09,272.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M140.79,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM140.88,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M144.18,270.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M149.33,268.7v.5h-1.98v-.5h1.98ZM147.93,267.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M150.49,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM150.2,272.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M154.08,268.06c-.11,0-.21-.04-.29-.12s-.12-.17-.12-.28.04-.2.12-.28c.08-.08.18-.12.29-.12s.21.04.29.12c.08.08.12.17.12.28s-.04.2-.12.28-.18.12-.29.12ZM153.78,272.52v-3.82h.59v3.82h-.59Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M158.49,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM158.58,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M161.88,270.22v2.3h-.59v-3.82h.57v.6h.05c.09-.19.23-.35.41-.47.18-.12.42-.18.71-.18.26,0,.49.05.68.16.19.11.34.26.45.48.11.21.16.48.16.81v2.43h-.59v-2.39c0-.3-.08-.53-.23-.7-.16-.17-.37-.25-.64-.25-.19,0-.35.04-.5.12-.15.08-.26.2-.35.36-.08.16-.13.34-.13.57Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M167.03,268.7v.5h-1.98v-.5h1.98ZM165.63,267.78h.59v3.64c0,.17.02.29.07.37s.11.14.19.16.16.04.25.04c.06,0,.12,0,.16-.01.04,0,.08-.01.1-.02l.12.53s-.09.03-.17.05-.16.02-.27.02c-.17,0-.33-.04-.49-.11-.16-.07-.29-.18-.39-.33s-.16-.33-.16-.55v-3.8Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M169.02,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM169.11,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: { d: "M172.41,267.43v5.09h-.59v-5.09h.59Z" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M176.53,272.61c-.24,0-.46-.05-.66-.14-.2-.09-.35-.22-.47-.4-.12-.17-.17-.39-.17-.64,0-.22.04-.4.13-.53s.2-.24.35-.32c.14-.08.3-.14.48-.18s.35-.07.53-.09c.23-.03.42-.05.57-.07.14-.02.25-.04.32-.08.07-.04.1-.1.1-.2v-.02c0-.25-.07-.44-.2-.57-.13-.14-.34-.2-.61-.2s-.5.06-.66.18c-.16.12-.27.25-.33.39l-.56-.2c.1-.23.23-.41.4-.54.17-.13.35-.22.55-.27.2-.05.39-.08.59-.08.12,0,.26.01.42.04.16.03.31.09.46.18.15.09.27.22.37.41.1.18.15.42.15.73v2.52h-.59v-.52h-.03c-.04.08-.11.17-.2.27s-.22.17-.37.24-.34.1-.56.1ZM176.62,272.08c.23,0,.43-.05.59-.14s.28-.21.36-.35c.08-.14.12-.3.12-.46v-.54s-.08.06-.16.08c-.08.02-.18.04-.29.06-.11.02-.21.03-.32.04-.1.01-.18.02-.25.03-.15.02-.29.05-.43.1-.13.04-.24.11-.32.2-.08.09-.12.21-.12.35,0,.2.08.36.23.46s.34.16.58.16ZM176.91,268.27c-.17,0-.32-.04-.46-.11-.14-.08-.25-.18-.33-.3-.08-.13-.12-.27-.12-.43s.04-.3.12-.44.19-.24.33-.32c.14-.08.29-.12.46-.12s.32.04.46.12c.14.08.24.19.32.32.08.13.12.28.12.44s-.04.3-.12.43c-.08.13-.19.23-.32.3-.13.07-.29.11-.46.11ZM176.91,267.89c.14,0,.25-.05.34-.14.09-.1.13-.2.13-.32s-.04-.24-.13-.34c-.09-.1-.2-.15-.34-.15s-.25.05-.34.15-.13.21-.13.34.04.23.13.32c.09.1.2.14.34.14Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-4",
            attrs: {
              d:
                "M179.34,272.52v-3.82h.57v.58h.04c.07-.19.2-.34.38-.46.18-.12.39-.18.62-.18.04,0,.1,0,.16,0,.06,0,.11,0,.15,0v.6s-.07-.01-.14-.02-.14-.02-.22-.02c-.19,0-.35.04-.5.12-.14.08-.26.18-.34.32-.08.13-.12.29-.12.46v2.42h-.59Z"
            }
          })
        ]),
        _vm._v(" "),
        _c("g", [
          _c("circle", { attrs: { cx: "189.45", cy: "38.34", r: "9.18" } }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-7",
            attrs: {
              d:
                "M194.13,43.87s-1.05,1.2-1.41,1.58c-.25.26-.57.73-.96.93-1.02.52-1.22.5-2.24.24-.43-.11-.83-.43-1.16-.73l-6.81-6.08c-.82-.74-.27-2.1.83-2.06l4.27.16c.52.02,1.02.23,1.4.58l6.09,5.36Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "gtl-cls-7",
            attrs: {
              d:
                "M186.62,44.36l2.04,1.82c1.19.84,2.62.87,3.66-.28l12.06-13.48c.69-.78.19-2.02-.88-2.14l-2.02-.24c-.92-.11-1.83.22-2.44.88l-12.42,13.45Z"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "text",
          {
            staticClass: "gtl-cls-3",
            attrs: { transform: "translate(5.07 150.57)" }
          },
          [
            _c("tspan", { attrs: { x: "0", y: "0" } }, [
              _vm._v(_vm._s(_vm.guarantee))
            ])
          ]
        ),
        _vm._v(" "),
        _c("g", [
          _c("rect", {
            staticClass: "gtl-cls-9",
            attrs: {
              x: "121.47",
              y: "127.8",
              width: "26.36",
              height: "22.68",
              rx: "1.66",
              ry: "1.66"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            staticClass: "gtl-cls-7",
            attrs: {
              x: "128.31",
              y: "124.74",
              width: "3.13",
              height: "6.19",
              rx: ".54",
              ry: ".54"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            staticClass: "gtl-cls-7",
            attrs: {
              x: "137.85",
              y: "124.74",
              width: "3.13",
              height: "6.19",
              rx: ".54",
              ry: ".54"
            }
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "gtl-cls-9",
            attrs: { x1: "121.47", y1: "133.96", x2: "147.83", y2: "133.96" }
          }),
          _vm._v(" "),
          _c("g", [
            _c("path", {
              staticClass: "gtl-cls-4",
              attrs: {
                d:
                  "M126.94,146.61c-.64,0-1.2-.11-1.69-.33-.49-.22-.88-.52-1.16-.91-.28-.39-.43-.83-.43-1.33h2.03c0,.18.07.34.18.48.11.14.26.25.44.33.19.08.4.12.64.12s.45-.04.63-.13.33-.2.43-.35c.1-.15.15-.32.15-.52,0-.2-.05-.37-.17-.52-.11-.15-.28-.27-.48-.35s-.45-.13-.74-.13h-.81v-1.43h.81c.25,0,.46-.04.65-.12s.34-.2.44-.34.16-.32.15-.51c0-.19-.04-.35-.13-.5s-.22-.25-.38-.33c-.16-.08-.35-.12-.56-.12-.22,0-.42.04-.6.12-.18.08-.32.19-.43.33-.11.14-.16.31-.17.5h-1.93c0-.5.14-.93.42-1.31.27-.38.64-.68,1.11-.89.47-.21,1-.32,1.6-.32s1.12.11,1.58.31.81.49,1.06.85c.25.36.38.77.38,1.22,0,.47-.15.86-.46,1.16-.31.3-.7.49-1.19.56v.07c.65.08,1.13.28,1.46.63s.49.77.49,1.28c0,.48-.14.91-.42,1.29-.28.37-.68.67-1.18.88-.5.21-1.08.32-1.73.32Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "gtl-cls-4",
              attrs: {
                d:
                  "M134.75,146.61c-.46,0-.89-.07-1.31-.22-.42-.15-.79-.38-1.12-.71s-.58-.75-.77-1.28c-.19-.53-.28-1.17-.28-1.93,0-.69.09-1.3.25-1.85.17-.55.4-1.01.71-1.4.31-.38.68-.68,1.11-.88.43-.2.91-.3,1.44-.3.58,0,1.1.11,1.55.34s.8.53,1.07.91c.27.38.43.81.48,1.27h-1.98c-.06-.26-.19-.46-.39-.6-.2-.14-.44-.21-.72-.21-.51,0-.89.22-1.14.66-.25.44-.38,1.03-.38,1.78h.05c.11-.25.28-.46.49-.64s.46-.32.74-.41c.28-.1.57-.15.89-.15.5,0,.94.12,1.32.35.38.23.68.55.9.95s.32.86.32,1.37c0,.58-.13,1.09-.41,1.54s-.65.79-1.14,1.04c-.48.25-1.05.37-1.68.37ZM134.74,145.06c.25,0,.47-.06.66-.18s.35-.28.46-.48c.11-.2.17-.43.16-.68,0-.26-.05-.48-.16-.68s-.26-.36-.46-.47-.42-.18-.67-.18c-.18,0-.35.03-.51.1-.16.07-.29.16-.41.28s-.21.26-.27.42c-.07.16-.1.34-.1.52,0,.25.06.47.17.67.11.2.26.36.46.48.19.12.41.18.66.18Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "gtl-cls-4",
              attrs: {
                d:
                  "M142.32,146.61c-.61,0-1.15-.11-1.62-.33-.47-.22-.85-.52-1.12-.91-.27-.39-.41-.83-.42-1.33h1.95c.02.31.14.55.37.74s.51.28.83.28c.25,0,.48-.06.67-.17.2-.11.35-.27.46-.47s.17-.44.16-.7c0-.27-.05-.5-.17-.7-.11-.2-.27-.36-.46-.47-.2-.11-.42-.17-.68-.17-.24,0-.47.05-.69.16-.22.11-.38.26-.49.44l-1.78-.33.36-4.5h5.35v1.62h-3.69l-.19,1.97h.05c.14-.23.36-.42.67-.57s.66-.23,1.05-.23c.5,0,.95.12,1.34.35.39.23.7.55.93.96s.34.88.34,1.41c0,.57-.13,1.08-.41,1.52-.27.44-.65.79-1.13,1.04s-1.05.38-1.7.38Z"
              }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }